var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWinnersPana = function SvgWinnersPana(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 48 750 280",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.9,419.34s.18-.17.54-.47l1.6-1.35,2.62-2.17,1.67-1.38c.59-.5,1.2-1.06,1.85-1.64l4.33-3.88c1.56-1.44,3.19-3.07,5-4.79S615.07,400,617,398s3.89-4.27,6-6.61,4.08-4.91,6.25-7.53c1.1-1.31,2.09-2.73,3.16-4.14s2.16-2.85,3.23-4.34,2.09-3.05,3.16-4.61c.54-.79,1.09-1.57,1.62-2.37s1-1.64,1.55-2.46c1-1.66,2.12-3.32,3.15-5l3-5.3c1.06-1.76,2-3.64,3-5.5s2-3.74,2.9-5.71l2.81-5.91c.86-2,1.74-4.07,2.62-6.14a206.64,206.64,0,0,0,14.26-53.54q.39-3.33.78-6.62c.17-2.2.33-4.37.5-6.53s.23-4.28.32-6.39.2-4.2.16-6.26,0-4.1,0-6.11-.16-4-.23-5.94q-.06-1.47-.12-2.91c0-1-.15-1.91-.22-2.86q-.24-2.84-.46-5.57c-.18-1.83-.43-3.62-.63-5.37s-.39-3.49-.69-5.17c-.58-3.35-1-6.6-1.68-9.65s-1.16-6-1.88-8.69-1.25-5.32-2-7.69-1.3-4.61-1.94-6.64-1.27-3.85-1.82-5.51c-.28-.83-.53-1.61-.79-2.34s-.52-1.4-.76-2c-.47-1.26-.87-2.32-1.19-3.19l-.73-2c-.16-.44-.23-.68-.23-.68s.11.22.28.66l.77,1.94c.34.87.76,1.93,1.24,3.17.25.63.51,1.31.79,2s.52,1.51.81,2.33l1.87,5.51c.65,2,1.27,4.25,2,6.63s1.32,5,2,7.69,1.28,5.64,1.93,8.7,1.12,6.3,1.71,9.66c.31,1.68.47,3.42.7,5.17s.46,3.55.65,5.38.31,3.7.47,5.59c.08.95.17,1.9.23,2.86s.09,1.94.13,2.91c.08,2,.19,4,.24,6s0,4.05,0,6.12-.09,4.16-.15,6.27-.11,4.26-.31,6.42-.33,4.33-.5,6.54-.52,4.4-.78,6.64a205.14,205.14,0,0,1-14.29,53.67c-.89,2.07-1.76,4.12-2.63,6.15l-2.82,5.92c-.9,2-1.94,3.84-2.92,5.72s-1.92,3.74-3,5.51l-3.07,5.3c-1,1.72-2.13,3.38-3.17,5l-1.56,2.47c-.52.8-1.08,1.58-1.62,2.37L636,375.6c-1.08,1.49-2.18,2.92-3.24,4.34s-2.08,2.83-3.19,4.13c-2.18,2.63-4.16,5.24-6.28,7.54s-4,4.59-6,6.59-3.75,4-5.58,5.67-3.44,3.33-5,4.77l-4.37,3.84c-.66.57-1.26,1.13-1.86,1.63l-1.69,1.36-2.65,2.13-1.64,1.31C594.1,419.2,593.9,419.34,593.9,419.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.09,380.2c-8.49-6.42-11.58-18.26-9.74-28.74s7.85-19.78,14.72-27.91c6.29,8,10.13,19.54,8.67,29.6s-7.19,18.38-13.65,27.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.05,380.21c-1.47-10.54,4.73-21.1,13.44-27.21s19.54-8.44,30.15-9.33c-1.2,10.09-6.67,21-14.8,27.06s-18.08,7.92-28.79,9.48",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.07,324.6c-8.09-4.17-12.41-13.69-12.39-22.79S655.41,284,660,276.16c6.46,5.8,11.38,15,11.62,23.66s-3.38,16.53-7.56,24.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664,324.61c-2.76-8.66.92-18.45,7.36-24.87s15.23-9.95,24-12.25c.46,8.67-2.56,18.64-8.53,24.95s-14.08,9.3-22.87,12.17",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.4,268.76c-7.31-1-13.2-7.1-15.66-14.06s-2-14.63-.59-21.88c6.51,2.68,12.76,8.37,15.3,14.94s1.91,13.56.95,21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.38,268.78c-4.47-5.88-4.32-14.36-1.13-21s8.94-11.75,15-15.89c2.71,6.5,3.11,14.95.26,21.39s-8.24,10.93-14.18,15.52",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.63,216.9c-6.52.51-12.76-3.69-16.18-9.26s-4.45-12.29-4.6-18.83c6.14,1.11,12.62,4.87,16,10.09s4.18,11.38,4.74,18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.61,216.92c-5-4.25-6.41-11.63-4.89-18s5.55-11.84,10.07-16.56c3.56,5.12,5.48,12.36,4.21,18.47s-5.1,11-9.39,16.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.59,178.62s7.21-24.06-17.25-28C646.34,150.66,639.92,172.91,663.59,178.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.91 232.43 381.91 232.44 381.94 232.44 381.91 232.43",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.82 232.43 381.9 232.44 381.84 232.41 381.82 232.43",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.73 232.37 381.67 232.44 381.81 232.44 381.73 232.37",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.61 232.36 381.63 232.34 381.6 232.34 381.61 232.36",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.59 232.18 381.59 232.19 381.61 232.21 381.59 232.18",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.88 232.35 381.87 232.37 381.89 232.39 381.88 232.35",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.56 232.39 381.55 232.32 381.18 232.21 381.51 232.42 381.56 232.39",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.57 232.33 381.56 232.39 381.61 232.36 381.57 232.33",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.86 232.33 381.81 232.34 381.84 232.36 381.86 232.33",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.82 232.4 381.8 232.39 381.81 232.42 381.82 232.4",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.05,20.11l15.33,106.66.43-.07,14.92,104.53,14.78-104.55.23,0L411.46,21.78a229.47,229.47,0,0,0-60.41-1.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.36,71.38a227.71,227.71,0,0,0-51.06-32.1l-43.54,95.95.23.1L382,232.1Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.57,202.47h0l101.36,29.68h-.4l1,.29h0l0,0h0l.07,0v0l0,0h0v0l0,0,.06-.07.08.06h-.14l.07.05.06,0v0h0l.06,0v0l0,0h0l-.07,0,.41.18-.33-.21,101.94,29.84-.06.22L597,295.76a228,228,0,0,0,5.42-49.5c0-4.74-.17-9.45-.45-14.12H488.21v.18L382,232.43h0l0,0v-.09l.47-.14-.38.25.94-.28h-.46L589.57,170.8A227.06,227.06,0,0,0,561.42,116l-179,116.12h-.37l.15-.18-.27.18h0v0l0,0,.1-.57-.2.43,0,.14-.12.09-.05-.09h-.08l0-.15-.17-.36.07.47,0,0h0l-.21-.14.11.13h-.35L192.43,110.67a227,227,0,0,0-31,57.22Zm102.34,30h0Zm-.09,0,0,0,.06,0Zm.06-.08v0l0,0Zm0,0,0,0,0,0Zm0,.07v0Zm-.21,0v0h0Zm0-.18,0,0,0,0Zm0,.15,0,0-.05,0Zm0,0v.07l-.05,0-.33-.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.91,151.81v0l69.55,80.26-44.11-96.66,0,0L291.33,34.75a227,227,0,0,0-54.27,30.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.32,290.12l-.06.1-89.1-57.37L451.64,313l-.17.14,82.66,95.57A228.16,228.16,0,0,0,574,356.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.88 232.66 381.86 232.65 381.87 232.67 381.88 232.66",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.62 232.46 381.61 232.49 381.57 232.46 381.58 232.54 381.59 232.53 381.59 232.54 381.66 232.52 381.62 232.5 381.65 232.47 381.67 232.47 381.66 232.45 381.67 232.44 381.57 232.44 381.62 232.46",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.54 232.56 381.55 232.45 381.53 232.44 381.11 232.68 381.54 232.56",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.29,232.88l-88.87,57.66-.21-.32L179.8,363a228.26,228.26,0,0,0,43.69,52.86l102-118.17Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.63,262.61l101.86-30.17L148,232.69c-.27,4.49-.42,9-.42,13.57a228,228,0,0,0,6.34,53.46l125.71-37.1Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.44,233.24,281.22,453.49A225.93,225.93,0,0,0,347.68,472Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.9 232.49 381.87 232.51 381.89 232.53 381.9 232.49",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,233.22,415.79,470A225.8,225.8,0,0,0,480,448Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.62 232.84 381.74 233.64 381.85 232.87 381.73 232.61 381.62 232.84",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.86 232.52 381.84 232.52 381.86 232.53 381.86 232.52",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.25,419.34s-.2-.14-.57-.43l-1.63-1.31-2.66-2.13-1.68-1.36c-.6-.5-1.21-1.06-1.87-1.63l-4.36-3.84c-1.57-1.44-3.21-3.06-5-4.77s-3.62-3.65-5.58-5.67-3.92-4.26-6-6.59-4.11-4.91-6.29-7.54c-1.1-1.3-2.11-2.72-3.18-4.13s-2.17-2.85-3.24-4.34L117,371c-.53-.79-1.09-1.57-1.62-2.37s-1-1.64-1.56-2.47c-1-1.66-2.13-3.32-3.17-5l-3.06-5.3c-1.07-1.77-2-3.65-3-5.51s-2-3.75-2.91-5.72l-2.82-5.92q-1.3-3-2.63-6.15a205.68,205.68,0,0,1-14.3-53.67l-.77-6.64q-.25-3.31-.5-6.54c-.2-2.16-.23-4.3-.31-6.42s-.2-4.2-.15-6.27,0-4.11,0-6.12.16-4,.24-6c0-1,.08-1.94.13-2.91s.15-1.91.22-2.86c.16-1.89.32-3.76.47-5.59s.44-3.61.65-5.38.4-3.49.71-5.17c.59-3.36,1-6.61,1.71-9.66s1.19-6,1.93-8.7,1.27-5.32,2-7.69,1.33-4.61,2-6.63,1.31-3.85,1.88-5.51c.28-.82.54-1.61.81-2.33l.78-2c.49-1.24.9-2.3,1.24-3.17s.59-1.49.77-1.94.28-.66.28-.66-.07.24-.23.68l-.72,2c-.32.87-.72,1.93-1.19,3.19l-.77,2c-.26.73-.5,1.51-.78,2.34l-1.83,5.51c-.63,2-1.24,4.26-1.93,6.64s-1.29,5-2,7.69-1.26,5.64-1.89,8.69-1.1,6.3-1.67,9.65c-.31,1.68-.46,3.41-.69,5.17s-.45,3.54-.64,5.37l-.45,5.57c-.07.95-.17,1.9-.22,2.86s-.08,1.93-.13,2.91c-.07,2-.18,3.93-.22,5.94l0,6.11c0,2.06.09,4.14.16,6.26s.11,4.24.32,6.39l.5,6.53q.39,3.28.78,6.62a205.58,205.58,0,0,0,14.26,53.54l2.62,6.14,2.8,5.91c.89,2,1.94,3.83,2.91,5.71s1.91,3.74,3,5.5l3.05,5.3c1,1.72,2.12,3.38,3.16,5,.52.82,1,1.64,1.55,2.46s1.08,1.58,1.61,2.37l3.17,4.61c1.07,1.49,2.17,2.92,3.22,4.34s2.07,2.83,3.17,4.14c2.16,2.62,4.14,5.23,6.25,7.53s4,4.61,6,6.61,3.73,4,5.54,5.69,3.42,3.35,5,4.79l4.33,3.88c.65.58,1.25,1.14,1.84,1.64l1.67,1.38,2.62,2.17,1.61,1.35C162.07,419.17,162.25,419.34,162.25,419.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.07,380.2c8.49-6.42,11.57-18.26,9.73-28.74s-7.84-19.78-14.72-27.91c-6.28,8-10.12,19.54-8.67,29.6s7.19,18.38,13.66,27.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.11,380.21c1.46-10.54-4.73-21.1-13.45-27.21s-19.53-8.44-30.14-9.33c1.19,10.09,6.66,21,14.8,27.06s18.08,7.92,28.79,9.48",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.09,324.6c8.09-4.17,12.41-13.69,12.38-22.79s-3.72-17.81-8.33-25.65c-6.46,5.8-11.37,15-11.61,23.66s3.38,16.53,7.56,24.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.12,324.61c2.77-8.66-.91-18.45-7.36-24.87s-15.23-9.95-24-12.25c-.46,8.67,2.56,18.64,8.52,24.95s14.08,9.3,22.87,12.17",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.76,268.76c7.31-1,13.2-7.1,15.65-14.06s2-14.63.6-21.88c-6.51,2.68-12.77,8.37-15.31,14.94s-1.9,13.56-.94,21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.78,268.78c4.47-5.88,4.31-14.36,1.12-21S72,236,65.86,231.87c-2.71,6.5-3.11,14.95-.26,21.39s8.24,10.93,14.18,15.52",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.53,216.9c6.52.51,12.76-3.69,16.18-9.26s4.44-12.29,4.59-18.83c-6.14,1.11-12.61,4.87-16,10.09s-4.17,11.38-4.73,18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.54,216.92c5-4.25,6.42-11.63,4.9-18s-5.56-11.84-10.07-16.56c-3.56,5.12-5.48,12.36-4.21,18.47s5.09,11,9.38,16.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.56,178.62s-7.21-24.06,17.25-28C109.81,150.66,116.24,172.91,92.56,178.62Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M519.57,182.38a20.54,20.54,0,0,0,27.81,22.31c8.58-3.37,14.27-12.2,23.06-15,3.8-1.19,7.91-1.15,11.68-2.44,4.53-1.55,8.46-5.28,9.48-10s-1.38-10.1-5.85-11.83c-2.35-.91-5.28-1-6.77-3-2.16-2.91.51-6.81,1.15-10.36.92-5.09-3-10.27-8-11.66s-10.48.5-14.36,3.92c-3.32,2.92-6.64,5.71-11,6.37a10.77,10.77,0,0,1-11.13-5.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.35,140.55a1.5,1.5,0,0,1,.11.49,8.55,8.55,0,0,1,0,1.45,9.5,9.5,0,0,1-1.78,5A9.29,9.29,0,0,1,551,150a9,9,0,0,1-4,1.28,10.06,10.06,0,0,1-4.63-.75,9.48,9.48,0,0,1-3.93-3.14,27.3,27.3,0,0,1-2.5-4.33,25,25,0,0,0-2.29-4,11.79,11.79,0,0,0-6.25-4.22,12.66,12.66,0,0,0-5.16-.34c-1.22.19-1.87.44-1.89.39a1.59,1.59,0,0,1,.46-.2,9.52,9.52,0,0,1,1.39-.39,12.28,12.28,0,0,1,5.29.19,12,12,0,0,1,6.54,4.28c1.86,2.38,2.84,5.57,4.83,8.25a8.91,8.91,0,0,0,3.71,3,9.56,9.56,0,0,0,4.39.74,8.79,8.79,0,0,0,3.86-1.17,8.91,8.91,0,0,0,2.62-2.38,9.54,9.54,0,0,0,1.87-4.77C555.42,141.24,555.3,140.55,555.35,140.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.71,133.47l-3.83,48.11L541,202.8s4.77,28.84,5,29.47l40.24-30.83a20.71,20.71,0,0,0,8.32-16l-1.69-55.59",
    style: {
      fill: "#936754"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.69,111.31c-.28-.16-4.34,10.63-4,12.28s4.4,6.58,6.07,7.58c3.13,1.85,1,8.6,1.33,9.67l16.15.85-.44-12.5,1.07-8.5a9.79,9.79,0,0,0,0-5.34c-.54-1.89-1.46-4-2.86-3.74-2.54.39-2.72,1.12-2.72,1.12s-1.7-2.52-3-.39c0,0-2.35-2.79-4.37-.38,0,0-2.7-2.66-4.58,1.45l-1,2.87S576.54,112.88,573.69,111.31Z",
    style: {
      fill: "#936754"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.77,125.25c-.08,0-.46-.75-1.37-1.76a6.43,6.43,0,0,0-4.64-2.14,7.91,7.91,0,0,0-.84,0h-.35l.08-.32c.48-1.86.93-3.51,1.28-4.68a8.83,8.83,0,0,1,.65-1.87,7.8,7.8,0,0,1-.31,2c-.26,1.2-.65,2.86-1.11,4.72l-.27-.32c.29,0,.59,0,.9,0a6.92,6.92,0,0,1,3,.8,6.75,6.75,0,0,1,1.92,1.62A4.82,4.82,0,0,1,580.77,125.25Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.73,116.39a3.13,3.13,0,0,1-.3.69,3.11,3.11,0,0,0-.37,1.87,1.79,1.79,0,0,0,.24.56,1.59,1.59,0,0,1-.52,2.34,2.51,2.51,0,0,1-3.56-1,3.43,3.43,0,0,1-.21-2c.1-.64.25-1.22.39-1.78a23.15,23.15,0,0,1,1-2.9,4.56,4.56,0,0,1,1.11-1.76c.41-.33.71-.34.71-.31s-.25.12-.57.45a5.14,5.14,0,0,0-.91,1.76,26.85,26.85,0,0,0-.86,2.88c-.22,1.08-.67,2.38-.18,3.47a2,2,0,0,0,2.81.81,1.4,1.4,0,0,0,.67-1.15c0-.39-.41-.79-.47-1.29a3,3,0,0,1,.55-2C590.52,116.57,590.7,116.37,590.73,116.39Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.59,120.94s0,.23-.26.52a1.94,1.94,0,0,1-1.49.55,2.4,2.4,0,0,1-2-1.32,4.4,4.4,0,0,1-.43-2.82,9.75,9.75,0,0,1,1.92-4.68c.78-1,1.46-1.51,1.5-1.46s-.52.61-1.2,1.67a10.73,10.73,0,0,0-1.71,4.53,4.12,4.12,0,0,0,.34,2.53,2.07,2.07,0,0,0,1.56,1.18,1.85,1.85,0,0,0,1.32-.33C586.46,121.1,586.55,120.92,586.59,120.94Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.84,120.35s-.05.19-.32.42a2.1,2.1,0,0,1-1.37.43,2.53,2.53,0,0,1-1.92-1,3.85,3.85,0,0,1-.79-2.49,6.57,6.57,0,0,1,.65-2.49c.32-.71.66-1.31.94-1.82a6.9,6.9,0,0,1,1-1.6,6.24,6.24,0,0,1-.66,1.76,12.22,12.22,0,0,0-1.4,4.16,3.46,3.46,0,0,0,.65,2.18,2.2,2.2,0,0,0,1.56.88A2.59,2.59,0,0,0,582.84,120.35Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.62,119s0,.22-.11.56a3.27,3.27,0,0,1-.87,1.33,2.14,2.14,0,0,1-2.34.38,2.3,2.3,0,0,1-.89-2.72,21.3,21.3,0,0,1,1.74-4.76,5.88,5.88,0,0,1,1.13-1.76,48.62,48.62,0,0,0-2.37,6.64,1.89,1.89,0,0,0,.62,2.18,1.77,1.77,0,0,0,1.88-.25,3.66,3.66,0,0,0,.91-1.12C578.5,119.16,578.59,119,578.62,119Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.53,123a13.52,13.52,0,0,0-3.95.14,13.88,13.88,0,0,0-3.58,1.71s.22-.44.81-.92a6.7,6.7,0,0,1,2.64-1.3,6.91,6.91,0,0,1,2.95-.07C588.14,122.7,588.55,122.93,588.53,123Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.56,214.92c-9.69.9-18.21-6.21-19.62-10.46a11.45,11.45,0,0,1,3.55-12.13c2.76-2.24,6.76-3.39,8.08-6.69,2.31-5.74-5.71-12.21-2.85-17.7,2-3.89,7.95-3.83,10.73-7.23,2.45-3,1.56-7.4,2.33-11.19,1.3-6.44,7.87-11,14.44-11.19s12.84,3.22,17.38,8S529.14,157,531.79,163c2.15,4.87,4.13,10.14,3.23,15.38-1.34,7.76-8.48,13-15.25,17-11,6.57-19.42,20.53-32.21,19.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472,197.31l-.17,0c-.12,0-.3,0-.52,0a5,5,0,0,1-1.9-.62,5.21,5.21,0,0,1-2.19-2.28,5.37,5.37,0,0,1-.14-4.17,5.2,5.2,0,0,1,1.39-2,10.94,10.94,0,0,1,2.21-1.48A21.64,21.64,0,0,0,473,185.3a5.43,5.43,0,0,0,1.79-2.17c.81-1.8.57-4,0-6.1s-1.53-4.22-1.95-6.57a10.86,10.86,0,0,1-.13-3.55,5.88,5.88,0,0,1,1.47-3.14,7.08,7.08,0,0,1,2.81-1.8,26.34,26.34,0,0,1,3-.88,11.28,11.28,0,0,0,5.11-2.3,10.45,10.45,0,0,0,2.69-4.07,21,21,0,0,0,1.05-7.11c0-.82,0-1.47,0-2a3.08,3.08,0,0,1,0-.69,3,3,0,0,1,.08.69c0,.45.07,1.12.1,2a20,20,0,0,1-.9,7.24,10.69,10.69,0,0,1-2.76,4.26,11.51,11.51,0,0,1-5.27,2.44c-1.93.53-4.13,1-5.58,2.56a5.46,5.46,0,0,0-1.34,2.88,10.36,10.36,0,0,0,.13,3.37c.4,2.28,1.38,4.37,1.93,6.55s.8,4.45-.1,6.41a5.71,5.71,0,0,1-1.95,2.35,20,20,0,0,1-2.44,1.42,11.1,11.1,0,0,0-2.15,1.41,4.75,4.75,0,0,0-1.32,1.88,4.9,4.9,0,0,0,2.09,6.14A6.14,6.14,0,0,0,472,197.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.09,380.61l19.07-8.83s15.39,16.41,19.07,15.12l-15.8-37.59-30.28,12.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560.09,380.61l19.07-8.83s15.39,16.41,19.07,15.12l-15.8-37.59-30.28,12.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M572.65,360.84A1.67,1.67,0,0,1,574,359a1.61,1.61,0,0,1,1.8,1.28,1.76,1.76,0,0,1-1.39,1.9c-.82,0-1.8-.73-1.72-1.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.43,349.31l-3,1.39,16.27,35.52s1.43,1.37,2.53.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.23,372.47c.18-.09-.12-1,.09-2.19s.78-2,.63-2.1-1.09.59-1.32,2S579.08,372.58,579.23,372.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.52,375.72c.19,0,.17-1,.68-1.9s1.26-1.48,1.18-1.66-1.17.14-1.79,1.33S582.34,375.79,582.52,375.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.18,376c0-.18-1.06-.05-1.87.84s-.84,1.92-.66,1.93.5-.74,1.18-1.46S588.23,376.17,588.18,376Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.66,374c.13-.15-.47-.88-.84-1.95s-.38-2-.58-2-.52,1-.07,2.27S574.55,374.15,574.66,374Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.78,375.71a3.87,3.87,0,0,0-.8-1.88,9.14,9.14,0,0,0-1.44-1.71,8.61,8.61,0,0,0-1-.84,2.7,2.7,0,0,0-.68-.39.88.88,0,0,0-1,.33,1.11,1.11,0,0,0-.08,1,2.83,2.83,0,0,0,.4.67,7.2,7.2,0,0,0,.89,1,7.09,7.09,0,0,0,1.87,1.25,3.34,3.34,0,0,0,2,.47c0-.11-.72-.29-1.76-.9a7.51,7.51,0,0,1-2.44-2.22c-.28-.36-.42-.69-.29-.87s.08-.08.23-.05a2,2,0,0,1,.5.28,11.68,11.68,0,0,1,1,.76,11.31,11.31,0,0,1,1.46,1.53C570.33,375.07,570.68,375.75,570.78,375.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.94,375.36a3.27,3.27,0,0,0-2,.27,6.59,6.59,0,0,0-1.95,1.12,6.12,6.12,0,0,0-.94,1,1.7,1.7,0,0,0-.45,1.6,1,1,0,0,0,.86.57,2.94,2.94,0,0,0,.77-.1,4.53,4.53,0,0,0,1.27-.53,4.76,4.76,0,0,0,1.61-1.62c.66-1.15.56-2,.49-2a18.41,18.41,0,0,1-.9,1.72,4.81,4.81,0,0,1-1.52,1.34,4.4,4.4,0,0,1-1.1.42c-.43.11-.81.09-.84-.07a1.19,1.19,0,0,1,.34-.92,7.2,7.2,0,0,1,.83-.9,7.58,7.58,0,0,1,1.72-1.15C570.19,375.56,571,375.47,570.94,375.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "562.29 372.37 556.17 358.85 543.5 364.82 531.61 388.33 562.29 372.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.3,388.54l19.33-8.25s14.88,16.88,18.6,15.71l-14.64-38.06-30.65,11.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.46,369.16a1.67,1.67,0,0,1,1.36-1.76,1.6,1.6,0,0,1,1.75,1.34,1.75,1.75,0,0,1-1.45,1.85c-.82,0-1.77-.78-1.67-1.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.59,357.94l-3.05,1.29,15.18,36s1.39,1.41,2.51.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.68,381c.18-.08-.09-1,.15-2.19s.84-1.93.7-2.07-1.1.54-1.38,1.94S600.52,381.09,600.68,381Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.86,384.34c.2,0,.21-.95.75-1.88s1.3-1.44,1.22-1.62-1.17.1-1.82,1.28S603.69,384.41,603.86,384.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.51,384.77c0-.18-1-.08-1.88.78s-.91,1.9-.72,1.92.52-.73,1.21-1.43S609.57,385,609.51,384.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.06,382.38c.14-.15-.44-.9-.77-2s-.32-2-.52-2.06-.55,1-.14,2.27S596,382.52,596.06,382.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.13,384a3.78,3.78,0,0,0-.74-1.9,9.17,9.17,0,0,0-1.38-1.76,8.55,8.55,0,0,0-1-.87,2.48,2.48,0,0,0-.67-.41.86.86,0,0,0-1,.3,1.12,1.12,0,0,0-.12,1,2.62,2.62,0,0,0,.38.67,6.8,6.8,0,0,0,.86,1,7.45,7.45,0,0,0,1.83,1.32,3.44,3.44,0,0,0,2,.52c0-.11-.72-.31-1.74-1a8.37,8.37,0,0,1-1.61-1.33,7.59,7.59,0,0,1-.76-1c-.26-.36-.4-.7-.26-.87s.08-.08.23,0a1.61,1.61,0,0,1,.49.29,11.09,11.09,0,0,1,1,.79,11.37,11.37,0,0,1,1.41,1.57A15.75,15.75,0,0,0,592.13,384Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.31,383.62a3.32,3.32,0,0,0-2,.21,6.8,6.8,0,0,0-2,1.06,8.42,8.42,0,0,0-1,.93,1.71,1.71,0,0,0-.49,1.59,1,1,0,0,0,.84.59,2.66,2.66,0,0,0,.77-.07,4.44,4.44,0,0,0,1.29-.5,4.64,4.64,0,0,0,1.65-1.57c.7-1.12.63-2,.56-2s-.23.76-1,1.69a4.65,4.65,0,0,1-1.56,1.29,4.06,4.06,0,0,1-1.11.39c-.43.1-.81.07-.83-.1s.1-.62.37-.9a5.85,5.85,0,0,1,.85-.87,6.92,6.92,0,0,1,1.76-1.1C591.54,383.8,592.32,383.74,592.31,383.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.69,314.79s47.85-6.6,57.62-13.87,9.37-9.47,9.37-9.47,1.53-7.5-4.45-8.47S513,289.77,513,289.77l-16.65-4.27-13.73,8.15L473.44,305s2.52,6.62,6.08,7.76a29.08,29.08,0,0,0,5.17,1.29",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M484.69,314.79s47.85-6.6,57.62-13.87,9.37-9.47,9.37-9.47,1.53-7.5-4.45-8.47S513,289.77,513,289.77l-16.65-4.27-13.73,8.15L473.44,305s2.52,6.62,6.08,7.76a29.08,29.08,0,0,0,5.17,1.29"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M486.89,306c-.36-.93-.82-13.23-.82-13.23s3.38-5.5,10-5.58,16.07,2.84,16.07,2.84l28-9.2,2.24,10.59s-21,17.84-32.23,17.79A88.92,88.92,0,0,1,486.89,306Z",
    style: {
      fill: "#936754"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.31,277.27h0a13.87,13.87,0,0,1-9.38-.16,20.61,20.61,0,0,1-9.52-7.09l-2.44-3.2c-2.84-2.81-20.63-27.22-20.63-27.22l9.47-15.32,21.38,24.94,6.12-16.95L473.44,245l-4.93,20.34C467.31,270.67,465.41,275.44,460.31,277.27Z",
    style: {
      fill: "#936754"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.75,201.55s5.1,7.55,6.4,10.07c1.06,2,5,8.59,4.79,15.49l-9.6,12.49s-4.61-3.53-5.35-4.85a4.52,4.52,0,0,1-.06-3.22,12.31,12.31,0,0,0-2.15-1.5s.44,2.36-1.33,2.8-7.65-5.74-7.65-5.74-.45-2.65,1.17-2.8c0,0-1.17-3.68,0-4.71,0,0-1.32-3,.3-4.27,0,0,.74-3.39,1.91-4.57s13.16,2.36,13.16,2.36-2.84-6.31-3.13-8.07S416.75,201.55,416.75,201.55Z",
    style: {
      fill: "#936754"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.38,224.82s.19.09.48.34a4,4,0,0,1,1,1.23,2.85,2.85,0,0,1,.41,1.09,2.67,2.67,0,0,1-.22,1.34,1.59,1.59,0,0,1-1.24.94,2.36,2.36,0,0,1-1.59-.37,19.85,19.85,0,0,1-2.2-1.9c-.59-.58-1.16-1.12-1.69-1.62a9.05,9.05,0,0,1-1.47-1.59,8.91,8.91,0,0,1,1.72,1.32l1.77,1.53a25.87,25.87,0,0,0,2.14,1.82c.77.52,1.84.39,2.12-.34a2.26,2.26,0,0,0,.23-1.09,2.52,2.52,0,0,0-.31-1,4.61,4.61,0,0,0-.86-1.26C409.47,225,409.35,224.84,409.38,224.82Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.73,214.25a15.57,15.57,0,0,1,2.21,1.87c.32.31.7.62,1.06,1a4.66,4.66,0,0,1,1,1.41,2.25,2.25,0,0,1-2.14,3,3.45,3.45,0,0,1-1.86-1l-1.36-1.25-2.29-2.13a15.54,15.54,0,0,1-2-2.07,16.79,16.79,0,0,1,2.27,1.79l2.36,2.06,1.38,1.22a3,3,0,0,0,1.57.87,1.76,1.76,0,0,0,1.65-2.3,8.86,8.86,0,0,0-1.91-2.34A16.52,16.52,0,0,1,408.73,214.25Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.71,221.54s.24-.06.61.12a2.06,2.06,0,0,1,1.07,1.34,2.1,2.1,0,0,1-2.64,2.45,4.24,4.24,0,0,1-1.42-.8,32.43,32.43,0,0,1-4-3.72,8,8,0,0,1-1.38-1.78c.12-.11,2.37,2.49,5.68,5.09a3.73,3.73,0,0,0,1.23.72,1.53,1.53,0,0,0,1.21-.11,1.64,1.64,0,0,0,.93-1.77,1.94,1.94,0,0,0-.81-1.24C410.92,221.63,410.7,221.58,410.71,221.54Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.68,233.51a1.17,1.17,0,0,1,0-.46,5.14,5.14,0,0,1,.27-1.28,5.44,5.44,0,0,1,3.09-3.31l.07.48h0v-.49h.06v.49H416l-.07-.12a10.41,10.41,0,0,1-1.19-3.2,11.3,11.3,0,0,1,.77-6.84,8.78,8.78,0,0,1,1.08-1.8c.32-.38.5-.58.53-.56s-.64.89-1.27,2.51a11.74,11.74,0,0,0-.6,6.59,10.4,10.4,0,0,0,1.11,3l-.21-.12h0l0,.49h-.05v-.49h0l1.17.05-1.1.43a5.36,5.36,0,0,0-3,2.95C412.81,232.87,412.76,233.53,412.68,233.51Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.54,259.46a16.92,16.92,0,0,1-1.71-5.12,17.26,17.26,0,0,1-.53-5.37c.16,0,.42,2.38,1,5.26S451.68,259.41,451.54,259.46Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.89,306c-.29.88-2.91,23-2.91,23s-18.88,46.59-21.58,60.67-.88,28.58,14.29,32.66,27.57-7.5,27.57-7.5,5.35,7.5,19.73,5.74c14.58-1.78,65.86-33.24,65.86-33.24l-8.75-22.66-40,15.08s20.1-39.59,21-49.87c.7-7.93-11-33.4-19.83-38.5,0,0-25.08,19.12-33.54,17.73S486.89,306,486.89,306Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.58,329.1a.81.81,0,0,1,0,.25c0,.19,0,.42-.06.71,0,.63-.18,1.56-.36,2.74a66.84,66.84,0,0,1-2.47,9.86c-1.31,4.09-3.23,8.84-5.48,14a177.21,177.21,0,0,0-6.64,17.16c-1,3.1-1.81,6.18-2.46,9.19a58.24,58.24,0,0,0-1.3,8.75A33.4,33.4,0,0,0,499,406.46a28.86,28.86,0,0,0,5.39,8.47c.82.87,1.47,1.53,1.94,1.95l.52.49a1,1,0,0,1,.17.19.75.75,0,0,1-.2-.15l-.56-.45c-.49-.4-1.17-1-2-1.89a28.14,28.14,0,0,1-5.58-8.47,33.15,33.15,0,0,1-2.36-14.83,56.42,56.42,0,0,1,1.27-8.83,94.75,94.75,0,0,1,2.47-9.24,169.78,169.78,0,0,1,6.69-17.19c2.27-5.19,4.22-9.9,5.57-14a73.58,73.58,0,0,0,2.62-9.78c.21-1.18.37-2.09.45-2.72.05-.29.08-.52.12-.71A.68.68,0,0,1,515.58,329.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.1,364.74a2.24,2.24,0,0,1-.52.24l-1.52.59-5.63,2.08c-4.75,1.76-11.34,4.15-18.53,7s-13.65,5.56-17.93,8.24l-1.47,1c-.42.37-.86.69-1.2,1a8.91,8.91,0,0,0-1.52,2l-.77,1.43a2.25,2.25,0,0,1-.31.49,3.07,3.07,0,0,1,.21-.53c.17-.34.37-.85.69-1.48a8.69,8.69,0,0,1,1.49-2.14c.34-.39.78-.72,1.2-1.11s1-.7,1.47-1.08c4.29-2.79,10.76-5.57,18-8.41s13.81-5.18,18.59-6.85l5.69-1.93,1.55-.5A2.08,2.08,0,0,1,581.1,364.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.14,330a2.37,2.37,0,0,1,0,.56c-.05.42-.12.95-.21,1.6a48.21,48.21,0,0,1-1.56,5.72A184.6,184.6,0,0,1,553,355.91c-3.18,6.94-6.26,13.12-8.54,17.56-1.14,2.22-2.09,4-2.75,5.23l-.79,1.41a2.29,2.29,0,0,1-.3.47,2.14,2.14,0,0,1,.21-.52c.19-.38.42-.86.7-1.45.64-1.32,1.53-3.11,2.6-5.31,2.2-4.48,5.22-10.68,8.39-17.6s5.84-13.29,7.48-18c.84-2.35,1.36-4.29,1.7-5.64l.31-1.57A2.07,2.07,0,0,1,562.14,330Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.49,331.43c-.15,0-1.14-4.95-2.22-11.12s-1.85-11.19-1.71-11.21,1.14,4.95,2.22,11.12S512.63,331.41,512.49,331.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,305.87a3.38,3.38,0,0,1-.73.7,11.53,11.53,0,0,1-2.36,1.43,12.78,12.78,0,0,1-16.19-4.67,11.25,11.25,0,0,1-1.24-2.47,3.16,3.16,0,0,1-.25-1,24.7,24.7,0,0,0,1.79,3.25,12.91,12.91,0,0,0,15.74,4.53A25.39,25.39,0,0,0,552,305.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.57,309a3.09,3.09,0,0,1,0,1,14.69,14.69,0,0,1-.36,2.6,18.17,18.17,0,0,1-10.76,12.85,16.52,16.52,0,0,1-2.5.81,3.32,3.32,0,0,1-1,.14c0-.09,1.32-.37,3.3-1.29a19.11,19.11,0,0,0,10.55-12.6C500.44,310.32,500.48,309,500.57,309Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.51,310.4a2.78,2.78,0,0,0-1.25,1,1.63,1.63,0,0,0-.08,1.58,1.68,1.68,0,0,0,3.13-.14,1.65,1.65,0,0,0-.22-1.57,2.77,2.77,0,0,0-1.34-.89s.17-.08.49,0a2.1,2.1,0,0,1,1.14.69,2,2,0,0,1,.38,2,2.14,2.14,0,0,1-4,.19,2.06,2.06,0,0,1,1.28-2.78C514.33,310.34,514.51,310.37,514.51,310.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.89,199.29l-20.5.65s-6.62,26.67-6.11,44.37c.3,10.83,7,26.17,8.63,31.81,1.13,3.93-2.88,9.28-4,13.21a1.09,1.09,0,0,1,0,.17c-1.67,5.68-9.48,25.29,9.89,25.29,0,0-10.08-5.55-5-15.42,4.89-9.5,14.35-13.63,22.36-8.95s10.68,2.67,18-.34,33.38-10.68,30,2.67c0,0,4-7.68-4-13.35-6.09-4.31-11.21-16.09-11.42-28.1-.11-6.35,2.59-13.17,7.62-17.05l8.81-6.52s-9.16.54-6.49-13.48,4.55-16.81,4.55-16.81l-17.43,5.75a6.17,6.17,0,0,1-1.86.19l-8.84-.48Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.5,233.67S463,209.29,467,205.32c3.6-3.61,10.4-5.38,10.4-5.38l-5.4,45.9Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.14,271.46a1.7,1.7,0,0,1-.22-.46c-.15-.37-.32-.82-.54-1.37-.44-1.2-1.14-2.91-1.85-5.08a94.11,94.11,0,0,1-4.47-17.29,42.21,42.21,0,0,1-.25-9.85c.29-3,.85-5.69,1.27-7.93s.77-4.06,1-5.31c.1-.58.18-1.06.25-1.45a1.82,1.82,0,0,1,.13-.5,2.46,2.46,0,0,1,0,.51c-.05.4-.1.88-.16,1.46-.14,1.27-.43,3.1-.82,5.35s-.89,4.92-1.15,7.91a43.05,43.05,0,0,0,.29,9.74,105.1,105.1,0,0,0,4.3,17.24c.66,2.18,1.31,3.91,1.69,5.13L478,271A1.66,1.66,0,0,1,478.14,271.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.43,257.86a4.88,4.88,0,0,1-.26-1.2,32.44,32.44,0,0,1-.39-3.34,44.46,44.46,0,0,1,4-21.59,30.78,30.78,0,0,1,1.56-3,5.43,5.43,0,0,1,.67-1c.08.05-.78,1.57-1.89,4.15a49.24,49.24,0,0,0-4,21.42C532.26,256.12,532.52,257.85,532.43,257.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M532.57,254.15a57.45,57.45,0,0,1,2.94-11.61,19.5,19.5,0,0,1,7.25-9.32,11,11,0,0,0,2.12-1.51,2.47,2.47,0,0,0,.72-2.37c-.45-1.39-2.35-1.63-3.77-1.25a11.3,11.3,0,0,0-6.63,5.67,27.39,27.39,0,0,0-2.6,8.54,35.82,35.82,0,0,0-.53,10.68"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M551.43,286.4s-.07,0-.17-.16-.27-.3-.46-.5a20.06,20.06,0,0,0-1.86-1.77,18.94,18.94,0,0,0-8.46-4,17.47,17.47,0,0,0-6.46,0,29.57,29.57,0,0,0-7,2.47c-2.4,1.12-4.86,2.45-7.56,3.53a26,26,0,0,1-4.26,1.3,17.2,17.2,0,0,1-4.6.24c-3.1-.29-6-1.3-8.77-1.9a20.81,20.81,0,0,0-8.18-.26,21.06,21.06,0,0,0-7,2.52,20,20,0,0,0-5,4.12,21,21,0,0,0-4.45,8.25,21.93,21.93,0,0,0-.56,2.51c0,.27-.07.49-.1.67a.93.93,0,0,1-.05.22,14,14,0,0,1,.51-3.46,20.78,20.78,0,0,1,4.37-8.43,20.08,20.08,0,0,1,5.06-4.25,21.29,21.29,0,0,1,7.12-2.62,21,21,0,0,1,8.38.24c2.84.6,5.69,1.59,8.71,1.87a16.52,16.52,0,0,0,4.45-.23,25.44,25.44,0,0,0,4.17-1.26c2.66-1.07,5.13-2.38,7.55-3.5a29.29,29.29,0,0,1,7.17-2.45,17.77,17.77,0,0,1,6.61.1,18.59,18.59,0,0,1,8.52,4.17A13.77,13.77,0,0,1,551.43,286.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525,245a1.61,1.61,0,0,1,0,.48c0,.32,0,.79,0,1.4a29.39,29.39,0,0,1-.63,5.1,33.36,33.36,0,0,1-21.23,24.7,30.79,30.79,0,0,1-4.94,1.39c-.59.12-1.06.17-1.38.21a1.81,1.81,0,0,1-.49,0,18.74,18.74,0,0,1,1.83-.45,37.27,37.27,0,0,0,4.85-1.53,34.13,34.13,0,0,0,21-24.44,36,36,0,0,0,.79-5A18.53,18.53,0,0,1,525,245Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M523.35,255.18a3.19,3.19,0,0,0-2.92,1.31,13.19,13.19,0,0,0-1.55,3,23,23,0,0,1-12.11,11.84,21.65,21.65,0,0,0-4.23,1.94,4.52,4.52,0,0,0-2.16,3.89s9.53-1.85,15.86-9.58S523.35,255.18,523.35,255.18Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M487.47,216.42a5.81,5.81,0,0,0-2.33-2.38c-1.86-.71-3.79,1-5.79,1-2.35,0-4-2.23-5.87-3.64-2.47-1.84-5.71-2.36-8.76-2.81l-1,1.89c2.69,1.78,6.85-.7,9.57,1,1.22.79,1.82,2.23,2.5,3.52s1.68,2.62,3.13,2.79,2.65-.8,4-1c4.32-.7,7.39,5.71,11.71,5A15,15,0,0,1,487.47,216.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.72,241.37c1.32-1.73,3.75-2.27,5.91-2a37.74,37.74,0,0,1,6.29,1.77,9.6,9.6,0,0,0,6.41.1,19.17,19.17,0,0,1,2.88-1.33c1.42-.32,2.86.26,4.25.7a23.94,23.94,0,0,0,9.06,1,21.87,21.87,0,0,1,3.52-.19,4.58,4.58,0,0,1,3.16,1.38,13.4,13.4,0,0,1,4.77-1.68c-1.92,1.35-3.94,2.73-6.27,3-2.68.32-5.28-.88-7.92-1.44-7.18-1.51-14.72,1.75-21.91.3a36.35,36.35,0,0,0-5-1,5.09,5.09,0,0,0-4.55,1.81",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.72,261.86c2.85.61,5.39-1.79,8.19-2.62,2.47-.72,5.12-.2,7.59.51s4.94,1.62,7.51,1.65c1.58,0,3.2-.3,4.72.13a23.43,23.43,0,0,1,3.34,1.63c3.66,1.72,7.94.79,11.86-.16a17.45,17.45,0,0,1-9.57,2.22,52.94,52.94,0,0,1-9.83-1.55l-7.86-1.76a15.16,15.16,0,0,0-6-.51c-3.37.63-6.25,3.52-9.66,3.19",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.93,275.67c2.09.2,4.17.35,6.27.45a17.73,17.73,0,0,0,5-.28c2.73-.67,5.15-2.54,8-2.73s5.6,1.41,8.49,1.61a8.93,8.93,0,0,0,7.17-2.92,25,25,0,0,1-12.9.31c-2-.47-4-1.2-6-.75-1.58.37-2.89,1.44-4.33,2.21-3.52,1.88-7.71,1.87-11.7,1.81",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.78,239.48c.21-2.28,8.27-4.31,11.59-7.21a6.26,6.26,0,0,1-4.33,5.08,24.61,24.61,0,0,1-3.84.51,5,5,0,0,0-3.42,1.62",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.36,223.38c1.35,1,3.28.75,4.91.22s3.3-1.24,5-.89,2.87,1.65,4.38,2.37a7.45,7.45,0,0,0,6.45-.19,9.92,9.92,0,0,0,4.45-4.81,6.16,6.16,0,0,1,1.61-2.6c.94-.68,2.21-.59,3.32-.94,1.77-.56,3-2.19,3.94-3.78s1.93-3.31,3.54-4.26c-1.4-.42-2.86.52-3.83,1.61s-1.77,2.4-3.05,3.12-2.85.72-4.14,1.4c-2.3,1.21-3,4.09-4.63,6.14-1.8,2.33-5.21,3.59-7.82,2.24-1.41-.73-2.57-2.15-4.16-2.17a6.46,6.46,0,0,0-2.87,1,12.81,12.81,0,0,1-7,1.33l.54.11",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.91,303.15a5.7,5.7,0,0,1,1.13-3.8c.74-1.13,1.66-2.14,2.32-3.32a41.52,41.52,0,0,0,1.92-5.35c.67-1.77,1.83-3.54,3.64-4.1,1.23-.38,2.57-.15,3.82-.42,2.12-.44,3.78-2.23,5.91-2.63,1.73-.33,3.51.31,5.27.23a6.49,6.49,0,0,0,4.26-1.92,6.84,6.84,0,0,1-4.73.4,11.87,11.87,0,0,0-4.8-.33c-1,.25-2,.81-3,1.09-1.92.51-4-.05-5.92.42-2.82.7-4.65,3.41-5.79,6.08s-1.28,4.77-3.19,7C473.77,296.46,472.31,302.17,472.91,303.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.89,202.75a12.31,12.31,0,0,1-2.33-1.15,2.9,2.9,0,0,1-1.4-1.94l-3,.1a7.79,7.79,0,0,0,5.89,4.66,8.49,8.49,0,0,1,2.14.28,16.44,16.44,0,0,1,2.09,1.3,1.79,1.79,0,0,0,2.25-.19A32.81,32.81,0,0,0,489.89,202.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.72,226.67a6.48,6.48,0,0,0-3.78-.14,8.29,8.29,0,0,1-3.8.11A11,11,0,0,1,460.3,225a3.66,3.66,0,0,0-2.85-.95l-.58,1.38c0,.59.54.29,1.11.46a3,3,0,0,1,1.6.71,5.74,5.74,0,0,1,.6,1.36,2.67,2.67,0,0,0,2.58,1.26,8.1,8.1,0,0,0,2.88-1,7.14,7.14,0,0,1,2.89-.88,3.79,3.79,0,0,1,3.55,2.45C472.71,228.68,471.88,227.2,470.72,226.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.52,199.23c1.17,1.64,3.49,2.08,5.48,1.68a28.46,28.46,0,0,0,5.6-2.27,8.55,8.55,0,0,1,5.88-.81c2.38.73,3.91,3.06,6.11,4.23a7.17,7.17,0,0,0,9-2.33,21.62,21.62,0,0,0,1.93-5c.59-1.71,1.54-3.45,3.18-4.19,1.93-.86,4.21-.11,6.24-.67,2.82-.78,4.38-3.86,4.78-6.75.75-5.29,3.71-15.87-16.94-17.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.33,158a19.59,19.59,0,0,0-17.6-21.93c-10.43-1-19.71,6.78-21.27,17.15-1.37,9.08-2.55,18.25-2.51,21.59.13,10,6,14,8.39,15.13a13.06,13.06,0,0,0,2.64.65h0s.07.05.06.08l-2.23,11.53c-1,7.56,3.2,14.3,10.75,15.4s13.48-4.7,14.64-12.26Z",
    style: {
      fill: "#936754"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.19,159.16c.17.24,1.49-.48,3.19-.22s2.82,1.28,3,1.1,0-.48-.53-.95A4.32,4.32,0,0,0,495.5,158a4.24,4.24,0,0,0-2.58.43C492.34,158.71,492.11,159.06,492.19,159.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508,161.77c.16.24,1.49-.47,3.19-.22s2.82,1.29,3,1.1,0-.48-.53-1a4.43,4.43,0,0,0-2.4-1.14,4.13,4.13,0,0,0-2.57.44C508.1,161.32,507.86,161.67,508,161.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.43,170.42a10.6,10.6,0,0,0-2.68-.91c-.43-.1-.83-.25-.86-.56a2.15,2.15,0,0,1,.48-1.24l1.76-3.12c2.47-4.45,4.33-8.13,4.15-8.23s-2.33,3.43-4.8,7.88c-.6,1.09-1.17,2.14-1.71,3.14a2.56,2.56,0,0,0-.48,1.67,1.09,1.09,0,0,0,.62.74,2.65,2.65,0,0,0,.73.21A11.43,11.43,0,0,0,501.43,170.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.05,190.61s6.49,1.5,15.42-2.24c0,0-3.86,8.3-16,5.35Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.56,174.62a3.09,3.09,0,0,1,2.91-.74,2.82,2.82,0,0,1,1.78,1.32,1.8,1.8,0,0,1-.16,2.05,2.09,2.09,0,0,1-2.31.23,6.4,6.4,0,0,1-2-1.61,1.93,1.93,0,0,1-.41-.57.59.59,0,0,1,.1-.64",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.27,172.32c-.28,0-.55,1.79-2.32,2.87s-3.71.59-3.76.85.39.42,1.21.56a4.64,4.64,0,0,0,3.13-.6,4,4,0,0,0,1.82-2.42C506.54,172.82,506.4,172.33,506.27,172.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.11,155.62c.1.48,1.83.51,3.79,1s3.5,1.31,3.82.94c.15-.18-.07-.66-.65-1.2a6.8,6.8,0,0,0-5.8-1.51C509.5,155.08,509.07,155.39,509.11,155.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.91,152.57c.24.43,1.47.2,2.88.38s2.57.64,2.9.28c.15-.18,0-.59-.45-1a4,4,0,0,0-2.25-1,4.07,4.07,0,0,0-2.41.44C494,152,493.8,152.36,493.91,152.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.1,185.56c.63-1.44,1.18-2.77,1.46-3.64,1.12-3.4,1.13-8.79-.48-12-1.5-3-5.3-5.92-6.4-8.81-1.69-4.43-.44-5.59-1.74-14.84-.74-5.25-7.74-12.52-15.08-11.39a15,15,0,0,0-8.82-4.66A21,21,0,0,0,490.69,139c-2.19,3.32-3.5,7.78-2.2,11.75,2.07,3.17,8.67,1.21,12.66-1a9.47,9.47,0,0,0,12.93-2.68,4.5,4.5,0,0,0,3.18,1.71c.13,1.17.27,2.16.36,2.79.4,2.89,4.75,7.08,4.8,10,.09,5.5-4.13,5.77-5.3,11.15-.88,4,2.19,6.42,2.77,10.52.09.63-7.27,14,2.22,19.61,0,0,.25.2.63.58a10,10,0,0,1,1.07,12.63c-2.49,3.7-5.15,9.82,1.21,13.11,0,0,1.85-5.86,4.46-7,6.63-2.89,13.4-3.44,10.67-17.81S541.06,191.71,543.1,185.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.85,126.33l4.65,53.88,27-2.16c.17-3.15,0-15.34,0-15.34s11.22-1.74,11.36-13c.07-5.45-.71-16.72-1.53-26.87a20.77,20.77,0,0,0-21.92-19.07h0A20.78,20.78,0,0,0,216.85,126.33Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.45,162.55a26.08,26.08,0,0,1-14.64-4.16s3.46,8.08,14.66,7.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.31,130.33a1.61,1.61,0,0,1-1.55,1.62,1.54,1.54,0,0,1-1.65-1.45,1.61,1.61,0,0,1,1.54-1.62A1.55,1.55,0,0,1,254.31,130.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.86,128.53c-.2.21-1.41-.69-3.14-.69s-3,.87-3.17.66.11-.47.66-.87a4.42,4.42,0,0,1,2.54-.79,4.21,4.21,0,0,1,2.5.81C255.78,128.06,256,128.43,255.86,128.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,130.73a1.61,1.61,0,0,1-1.55,1.62,1.53,1.53,0,0,1-1.65-1.44,1.6,1.6,0,0,1,1.54-1.62A1.53,1.53,0,0,1,237,130.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.9,128.85c-.2.21-1.41-.69-3.14-.69s-3,.87-3.17.66.11-.47.66-.87a4.42,4.42,0,0,1,2.54-.79,4.28,4.28,0,0,1,2.5.81C238.82,128.38,239,128.76,238.9,128.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.16,141.64a12.21,12.21,0,0,1,2.81-.5c.44,0,.85-.14.93-.44a2.23,2.23,0,0,0-.3-1.3c-.41-1.07-.84-2.19-1.3-3.36-1.81-4.77-3.12-8.7-2.92-8.77s1.81,3.74,3.62,8.52l1.25,3.37a2.56,2.56,0,0,1,.23,1.73,1.12,1.12,0,0,1-.73.65,3.09,3.09,0,0,1-.74.1A11.32,11.32,0,0,1,245.16,141.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.09,142.84c.28,0,.28,1.85,1.88,3.18s3.6,1.13,3.62,1.39-.45.36-1.29.38a4.62,4.62,0,0,1-3-1,4.1,4.1,0,0,1-1.46-2.67C239.75,143.29,240,142.83,240.09,142.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.35,122.09c-.17.47-1.89.25-3.92.49s-3.66.79-3.93.37c-.12-.2.17-.64.83-1.09a6.41,6.41,0,0,1,2.91-1,6.62,6.62,0,0,1,3.07.36C239.05,121.5,239.42,121.87,239.35,122.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.23,123.53c-.31.4-1.49,0-2.92,0s-2.64.26-2.92-.15c-.12-.2.07-.59.6-1a4.22,4.22,0,0,1,4.7.15C255.2,122.94,255.36,123.34,255.23,123.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,114l-.06,0a8.84,8.84,0,0,0-3.28,5.71,2.23,2.23,0,0,0,0,.23c-.43,3.2-.36,6.46-.82,9.66s-1.58,6.45-4,8.65c-1,.91-2.69,1.53-3.49.47a2.73,2.73,0,0,1-.4-1.47c-.6-7.73-2.71-14.59-2.7-22.67a6.83,6.83,0,0,1,2.83-5.55c1.7-1.21,3.76-2.47,5.64-1.58s4.32,4.41,5.78,5.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.64,131.4c-.2-.08-7.72-2.28-7.47,5.4s7.9,5.84,7.9,5.62S220.64,131.4,220.64,131.4Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.64,139.59s-.13.1-.36.21a1.31,1.31,0,0,1-1,0c-.82-.27-1.54-1.54-1.62-2.92A4.39,4.39,0,0,1,216,135a1.55,1.55,0,0,1,1-1.06.69.69,0,0,1,.81.34c.11.21.06.37.1.38s.16-.14.09-.45a.85.85,0,0,0-.32-.47,1,1,0,0,0-.74-.17,1.88,1.88,0,0,0-1.36,1.23,4.57,4.57,0,0,0-.4,2.15c.1,1.55.94,3,2.06,3.26a1.44,1.44,0,0,0,1.22-.25C218.63,139.78,218.66,139.6,218.64,139.59Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.73,109.91c-2.34-2.74,2.09-7.9,5.64-9.66s8.77-.72,12.69-.07c2.47.41,5,1.13,7.44.63a17,17,0,0,0,4.62-2,12.42,12.42,0,0,1,4.7-1.72A4.65,4.65,0,0,1,261.21,99c.87,1.43.3,3.68-1.31,4.17a3.77,3.77,0,1,1,2.08,6.74c.95-1,2.81.1,2.89,1.47a4,4,0,0,1-2.14,3.28c-2.94,1.89-6.7,2-10.15,1.43s-6.75-1.82-10.18-2.49-9.2-1.94-12.27-.28c-2.27,1.22-3.48,4.37-4.94,4a4.68,4.68,0,0,1-2.93-3,13.44,13.44,0,0,1-.53-4.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.68,131.07s.33-.21.62-.82a5.17,5.17,0,0,0,.39-2.78c-.17-2.48-2.36-5.13-2.64-8.55a7.75,7.75,0,0,1,.85-4.58,5.91,5.91,0,0,1,2.85-2.46,4.94,4.94,0,0,1,2.56-.35c.62.1.95.24,1,.18s-.27-.27-.91-.47a4.77,4.77,0,0,0-2.81.14A6.12,6.12,0,0,0,217.3,114a8.07,8.07,0,0,0-1,5,13.62,13.62,0,0,0,1.48,4.83,14.73,14.73,0,0,1,1.37,3.71A5.87,5.87,0,0,1,218.68,131.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.94,91.64s.12.09.3.31a4.1,4.1,0,0,1,.58,1.08,5.21,5.21,0,0,1-.66,4.39,7.66,7.66,0,0,1-5.84,3c-2.56.2-5.27-.56-8-1.27a23.44,23.44,0,0,0-4.07-.73,10.92,10.92,0,0,0-3.78.34,12.41,12.41,0,0,0-8,6.85c-.43,1-.54,1.52-.6,1.51s0-.15.06-.42a7.07,7.07,0,0,1,.36-1.17,11.37,11.37,0,0,1,2.39-3.78,12.45,12.45,0,0,1,5.66-3.46,11.38,11.38,0,0,1,3.94-.38,23.45,23.45,0,0,1,4.16.74c2.78.71,5.42,1.46,7.86,1.29a7.32,7.32,0,0,0,5.58-2.73,5.1,5.1,0,0,0,.76-4.12A6.41,6.41,0,0,0,251.94,91.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.43,363.53l-15.14-19.32s-24.72,8.9-27.87,5.6l36.41-30.7,24.82,29.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.88,336.3a2,2,0,0,0-.4-2.57,1.88,1.88,0,0,0-2.55.38,2.06,2.06,0,0,0,.44,2.71,1.94,1.94,0,0,0,2.61-.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,319.11l2.39,3-35.8,28.3s-2.22.66-3-.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.86,344.89c-.15-.18.67-1,1.07-2.32s.22-2.45.45-2.51.82,1.18.32,2.76S196,345.09,195.86,344.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.71,346.54c-.19-.14.32-1.09.29-2.36s-.52-2.2-.34-2.34,1.15.77,1.15,2.34S190.85,346.7,190.71,346.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.68,343.79c.13-.17,1.13.51,1.49,1.87s-.14,2.44-.34,2.36-.12-1-.44-2.15S184.52,344,184.68,343.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.79,348.92c-.06-.23,1-.67,1.91-1.59s1.47-1.89,1.69-1.82,0,1.35-1.13,2.41S199.83,349.13,199.79,348.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.92,352.76c-.06-.07.55-.78,1.83-1.53a10.37,10.37,0,0,1,2.4-1,11.66,11.66,0,0,1,1.52-.33,3.28,3.28,0,0,1,.91,0,1,1,0,0,1,.88.88,1.25,1.25,0,0,1-.44,1.06,3,3,0,0,1-.76.49,8.24,8.24,0,0,1-1.46.56,8.51,8.51,0,0,1-2.61.32,3.91,3.91,0,0,1-2.32-.58c0-.13.91.08,2.31,0a9.77,9.77,0,0,0,2.4-.46,8.28,8.28,0,0,0,1.32-.56c.47-.22.8-.5.76-.75s0-.13-.22-.17a2,2,0,0,0-.67,0,12.33,12.33,0,0,0-1.42.26,13,13,0,0,0-2.34.81A15.44,15.44,0,0,1,202.92,352.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.94,352.31c0-.08.93.26,2,1.35a7.69,7.69,0,0,1,1.44,2.21,8.23,8.23,0,0,1,.47,1.5,2,2,0,0,1-.39,1.9,1.1,1.1,0,0,1-1.19.13,2.9,2.9,0,0,1-.75-.51,5.2,5.2,0,0,1-1-1.23,5.52,5.52,0,0,1-.81-2.54c-.08-1.54.48-2.38.55-2.33a17.77,17.77,0,0,0,0,2.27,5.52,5.52,0,0,0,.87,2.2,4.93,4.93,0,0,0,.92,1c.38.34.79.53.9.36a1.33,1.33,0,0,0,.14-1.13,8.08,8.08,0,0,0-.38-1.37,8.94,8.94,0,0,0-1.18-2.12C203.61,352.92,202.86,352.42,202.94,352.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.78,376.36,158.64,357s-24.72,8.89-27.87,5.6l36.41-30.7L192,361.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.23,349.12a1.94,1.94,0,0,0-.4-2.56,1.88,1.88,0,0,0-2.55.37,2.07,2.07,0,0,0,.44,2.72,2,2,0,0,0,2.61-.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.18,331.94l2.39,3-35.8,28.3s-2.22.66-3-.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.21,357.72c-.15-.18.67-1,1.07-2.32s.23-2.45.45-2.52.82,1.18.32,2.76S158.31,357.91,158.21,357.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.06,359.36c-.19-.14.33-1.09.3-2.35s-.53-2.21-.35-2.35,1.15.77,1.15,2.34S153.2,359.52,153.06,359.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,356.62c.13-.18,1.13.5,1.49,1.86s-.14,2.45-.34,2.36-.12-1-.44-2.15S146.87,356.78,147,356.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.15,361.74c-.07-.23,1-.67,1.9-1.58s1.47-1.9,1.69-1.82,0,1.34-1.13,2.4S162.18,362,162.15,361.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.27,365.58c-.06-.07.55-.77,1.83-1.53A11.26,11.26,0,0,1,171,362.7a3,3,0,0,1,.91,0,1,1,0,0,1,.88.87,1.31,1.31,0,0,1-.43,1.07,3.54,3.54,0,0,1-.77.48,9.16,9.16,0,0,1-1.46.57,8.44,8.44,0,0,1-2.61.31,3.91,3.91,0,0,1-2.32-.58c0-.12.91.09,2.31,0a9.32,9.32,0,0,0,2.4-.46,8.28,8.28,0,0,0,1.32-.56c.47-.22.8-.49.76-.75,0-.09,0-.12-.22-.17a2.57,2.57,0,0,0-.66,0,12.12,12.12,0,0,0-1.43.26,13.36,13.36,0,0,0-2.33.81A15.84,15.84,0,0,1,165.27,365.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.29,365.13c0-.08.93.26,2,1.36a7.49,7.49,0,0,1,1.44,2.2,7.73,7.73,0,0,1,.47,1.5,2,2,0,0,1-.39,1.9,1.12,1.12,0,0,1-1.19.14,3.5,3.5,0,0,1-.75-.51,5.4,5.4,0,0,1-1-1.23A5.56,5.56,0,0,1,165,368c-.08-1.55.48-2.38.55-2.34a17.77,17.77,0,0,0,0,2.27,5.46,5.46,0,0,0,.87,2.2,5,5,0,0,0,.92,1c.39.34.79.53.91.37a1.39,1.39,0,0,0,.13-1.14A8.35,8.35,0,0,0,168,369a8.66,8.66,0,0,0-1.18-2.11C166,365.74,165.21,365.24,165.29,365.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.91,55.41c.37-.1,2,13.36,1.15,15.15s-6.75,7-9,7-5.34,3.31-6,4.45L162.28,79l3.31-8.15-.4-10.24a11.5,11.5,0,0,1,1.44-6.11c1.14-2,2.76-4.13,4.3-3.5,2.8,1.14,2.8,2,2.8,2s2.65-2.41,3.55.39c0,0,3.45-2.55,5.11.76,0,0,3.81-2.29,4.83,2.93l.38,3.56S187.22,56.43,190.91,55.41Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,71.63a6.33,6.33,0,0,1,1.58-1.85,14.36,14.36,0,0,1,7.41-3.49l-.21.25c0-1.7-.19-3.16-.22-4.23a5.84,5.84,0,0,1,.09-1.68,7.91,7.91,0,0,1,.23,1.66,38.38,38.38,0,0,1,.4,4.24v.22l-.21,0a15.4,15.4,0,0,0-2.23.55,16.3,16.3,0,0,0-5,2.73C179.62,71,179,71.69,179,71.63Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,56.53a2.25,2.25,0,0,1,.36.81,3.58,3.58,0,0,1,.06,2.47c-.2.54-.78.88-.9,1.35A1.69,1.69,0,0,0,170,62.7a2.45,2.45,0,0,0,3.51-.15,3.72,3.72,0,0,0,.69-2c.06-.71.07-1.42.07-2.08a29.84,29.84,0,0,0-.21-3.54,5.88,5.88,0,0,0-.57-2.27c-.28-.47-.57-.63-.54-.67s.35.08.71.56a5.46,5.46,0,0,1,.77,2.33,26.7,26.7,0,0,1,.32,3.58,19.5,19.5,0,0,1-.05,2.14,4.16,4.16,0,0,1-.78,2.25,2.92,2.92,0,0,1-4.28.14,2.11,2.11,0,0,1-.5-2,2.08,2.08,0,0,1,.54-.78,2.21,2.21,0,0,0,.44-.59,3.6,3.6,0,0,0,.07-2.26A4.05,4.05,0,0,1,170,56.53Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5,62.88s.09.22.34.54a2.17,2.17,0,0,0,1.43.77,2.48,2.48,0,0,0,2.15-.93,4.83,4.83,0,0,0,1.09-2.82,12.45,12.45,0,0,0-.71-5.68c-.5-1.4-1-2.18-1-2.23a5.71,5.71,0,0,1,1.29,2.1,11.51,11.51,0,0,1,.89,5.86,5.16,5.16,0,0,1-1.26,3.1,2.81,2.81,0,0,1-2.56,1,2.22,2.22,0,0,1-1.54-1C173.45,63.14,173.47,62.88,173.5,62.88Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,63.23s.14.17.4.42a2.5,2.5,0,0,0,1.36.63,2.63,2.63,0,0,0,2.07-.58,4.13,4.13,0,0,0,1.36-2.34c.37-2-.26-3.82-.47-5.15a9.42,9.42,0,0,1-.3-2.2,9.28,9.28,0,0,1,.66,2.11c.17.67.39,1.44.56,2.35a7.69,7.69,0,0,1,.06,3,4.45,4.45,0,0,1-1.57,2.61,2.92,2.92,0,0,1-2.43.56,2.44,2.44,0,0,1-1.45-.85C178,63.47,177.93,63.24,178,63.23Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.15,62.85s.09.22.2.63a4.14,4.14,0,0,0,.73,1.55,2.1,2.1,0,0,0,2.12.82,2.25,2.25,0,0,0,1.34-2.36,34.48,34.48,0,0,0-.51-5.84,19.53,19.53,0,0,1-.41-2.42,8.29,8.29,0,0,1,.77,2.34,25.92,25.92,0,0,1,.67,5.92,2.69,2.69,0,0,1-1.75,2.83,2.49,2.49,0,0,1-2.53-1.07,3.86,3.86,0,0,1-.63-1.73A1.46,1.46,0,0,1,183.15,62.85Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.66,198.82s-5,7.4-6.28,9.88c-1,2-5.08,10.38-5.26,15.79l10,11.62s4.52-3.45,5.25-4.75a4.46,4.46,0,0,0,0-3.16,12.23,12.23,0,0,1,2.11-1.46s-.43,2.31,1.3,2.74,7.51-5.63,7.51-5.63.43-2.59-1.16-2.74c0,0,1.16-3.61,0-4.62,0,0,1.3-2.88-.29-4.18,0,0-.72-3.32-1.87-4.48s-12.9,2.31-12.9,2.31,2.78-6.18,3.07-7.91S324.66,198.82,324.66,198.82Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.89,221.63s-.1.19-.33.47a4.63,4.63,0,0,0-.84,1.24,2.37,2.37,0,0,0-.3.93,2.21,2.21,0,0,0,.22,1.08c.27.7,1.32.83,2.07.32a21.84,21.84,0,0,0,2.1-1.78l1.74-1.5a8.75,8.75,0,0,1,1.68-1.29,8.77,8.77,0,0,1-1.43,1.56l-1.66,1.59a20.21,20.21,0,0,1-2.16,1.87,2.27,2.27,0,0,1-1.56.35,1.53,1.53,0,0,1-1.22-.92,2.66,2.66,0,0,1-.21-1.31,2.75,2.75,0,0,1,.4-1.07,3.74,3.74,0,0,1,1-1.21C331.7,221.72,331.86,221.6,331.89,221.63Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.52,211.27a15.09,15.09,0,0,1-1.9,2.09,8.81,8.81,0,0,0-1.87,2.29,1.73,1.73,0,0,0,1.62,2.25,2.94,2.94,0,0,0,1.53-.85l1.35-1.2,2.32-2a15.41,15.41,0,0,1,2.22-1.75,15.51,15.51,0,0,1-2,2l-2.25,2.1-1.33,1.22a3.4,3.4,0,0,1-1.83,1,2.2,2.2,0,0,1-2.1-2.94,4.56,4.56,0,0,1,1-1.39c.35-.38.73-.69,1-1A15.75,15.75,0,0,1,332.52,211.27Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.58,218.41c0,.05-.2.09-.5.3a2,2,0,0,0-.8,1.21,1.63,1.63,0,0,0,.92,1.74,1.5,1.5,0,0,0,1.18.1,3.87,3.87,0,0,0,1.21-.7c3.24-2.55,5.45-5.09,5.56-5a7.11,7.11,0,0,1-1.34,1.75,31.28,31.28,0,0,1-3.9,3.64,4.18,4.18,0,0,1-1.39.8,2,2,0,0,1-1.54-3.73A.87.87,0,0,1,330.58,218.41Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.65,230.15c-.08,0-.14-.63-.53-1.6a5.31,5.31,0,0,0-2.9-2.89l-1.1-.42,1.16-.05h0l0,.49h-.06v-.48h0l-.2.13a10.46,10.46,0,0,0,1.09-3,11.64,11.64,0,0,0-.59-6.45c-.62-1.59-1.33-2.4-1.25-2.46s.22.17.53.54a9.26,9.26,0,0,1,1.06,1.77,11.1,11.1,0,0,1,.76,6.7,10,10,0,0,1-1.18,3.14l-.07.12h-.16v-.48h.05l0,.49h0l.07-.47a5.3,5.3,0,0,1,3,3.24,5,5,0,0,1,.27,1.25A1.17,1.17,0,0,1,328.65,230.15Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.45,293.58,201,307a84.26,84.26,0,0,0,.06,19.18l5.86,49.69-18.74-22.24s-18,10.82-18.28,21.18c0,0,35.37,40.16,44.32,45.81s32,0,33-17.66c0,0,2.12,16.25,22.61,15.78s20.73-49.47,20.73-49.47l-8.95-73.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.24,403.4a3.08,3.08,0,0,1,0-.69c0-.49,0-1.14,0-1.95.06-1.75.15-4.19.25-7.17.25-6.1.61-14.44,1-23.64.22-4.62.43-9,.62-13s.23-7.62.91-10.62a10.87,10.87,0,0,1,3.54-6.19,6.32,6.32,0,0,1,1.68-1,2.35,2.35,0,0,1,.48-.17c.11,0,.17-.05.17,0a9.18,9.18,0,0,0-2.2,1.38,10.92,10.92,0,0,0-3.31,6.12c-.63,2.94-.59,6.57-.79,10.57s-.37,8.4-.58,13c-.44,9.2-.85,17.53-1.15,23.63-.17,3-.3,5.41-.4,7.16-.06.81-.11,1.45-.14,2A5.55,5.55,0,0,1,247.24,403.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.72,294.65a5.38,5.38,0,0,1,.28,1.2c.14.78.32,1.91.52,3.31.4,2.81.85,6.7,1.17,11s.43,8.23.44,11.06c0,1.42,0,2.57,0,3.36a5.8,5.8,0,0,1-.09,1.23,5.6,5.6,0,0,1-.11-1.23c0-.9-.08-2-.13-3.35-.1-2.82-.28-6.73-.59-11s-.71-8.19-1-11c-.15-1.32-.27-2.44-.36-3.33A6.65,6.65,0,0,1,252.72,294.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.56,298s.14-.17.52-.25a2.08,2.08,0,0,1,1.56.33,2.14,2.14,0,0,1,.76.86,2,2,0,0,1,.15,1.32,2.47,2.47,0,0,1-2.17,1.92,2.59,2.59,0,0,1-2.42-1.59,2.37,2.37,0,0,1,.3-2.35,2.45,2.45,0,0,1,1.27-.95c.36-.11.57-.09.57-.06a3.4,3.4,0,0,0-1.54,1.21,2,2,0,0,0-.16,2,2.16,2.16,0,0,0,1.95,1.26,2,2,0,0,0,1.74-1.51,1.67,1.67,0,0,0-.66-1.76,2.09,2.09,0,0,0-1.33-.44C245.76,297.93,245.57,298,245.56,298Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.29,375.7c.09,0-.31,1.51-.66,4a41.3,41.3,0,0,0-.24,9.62,40.6,40.6,0,0,0,2.08,9.4c.82,2.33,1.49,3.72,1.41,3.76a5.16,5.16,0,0,1-.55-.94,26.57,26.57,0,0,1-1.21-2.69,35.78,35.78,0,0,1-1.86-19.21,26.63,26.63,0,0,1,.67-2.88A4.55,4.55,0,0,1,207.29,375.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.94,397.61a10.28,10.28,0,0,0,1-.44,4.8,4.8,0,0,0,1.84-2.31,13.44,13.44,0,0,0,.89-4.69c.09-1.88.19-4,.2-6.4.06-4.74-.14-10.39-.69-16.63s-1.45-13.09-2.63-20.23-2.42-14-3.2-20.19a110.78,110.78,0,0,1-1.05-16.66,67.26,67.26,0,0,1,1.09-11.2c.22-1.31.52-2.3.67-3,.08-.31.14-.56.19-.77a1.1,1.1,0,0,1,.09-.26,1.35,1.35,0,0,1,0,.28c0,.2-.08.46-.14.78-.12.69-.38,1.68-.57,3a72.73,72.73,0,0,0-.93,11.17,115.67,115.67,0,0,0,1.17,16.59c.8,6.22,2.06,13,3.24,20.16s2.07,14,2.59,20.27a160.41,160.41,0,0,1,.58,16.69c0,2.37-.16,4.52-.28,6.41a13.65,13.65,0,0,1-1,4.75,4.8,4.8,0,0,1-2,2.33A2.84,2.84,0,0,1,206.94,397.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.93,358.15a7.51,7.51,0,0,1,1.13.91c.69.61,1.68,1.52,2.85,2.7a74,74,0,0,1,8.31,9.95c1.46,2.07,2.75,4.11,3.9,6a30.87,30.87,0,0,0,3.34,4.7,9.73,9.73,0,0,0,3.07,2.31c.84.36,1.35.45,1.34.5s-.13,0-.38,0a5.92,5.92,0,0,1-1-.27,9.12,9.12,0,0,1-3.25-2.25,27.44,27.44,0,0,1-3.48-4.7c-1.17-1.85-2.47-3.87-3.93-5.93a87.84,87.84,0,0,0-8.14-10c-1.13-1.2-2.08-2.15-2.73-2.81A7.75,7.75,0,0,1,181.93,358.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.93,160.82s-11.54-4.33-16.83-8.65-20.37-28.47-20.37-28.47l7.62-43.52L161.77,71s-21.58,51.79-19.18,61.4S184,195.47,184,195.47l9.58,38,10.1,34.13s-4.33,1.93-1.92,8.66,5.5,9.65,2.4,11.06c-5,2.28-1.71,6.3-1.71,6.3l81.14,2s-10.39-65.87-8.6-77.9c1.82-12.27.06-33.19.06-33.19l-18.48-5.63Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.05,184.48c8.42,3.87,17.38,58.74,17.38,58.74l19.65-20.9,12,15.13s-17,29.81-20.87,32.85c-3.29,2.56-13.21,10.31-19.89,7.66s-10.86-50.11-10.86-50.11Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.64,165.55s-1-6.41,1.12-5.45c.09,0,29.8,9.38,29.59,11.45-.17,1.75.21,7.3.21,7.3H230Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18,207.27a11.5,11.5,0,0,1,0-1.59c0-.52,0-1.14,0-1.87s0-1.55-.05-2.46a58,58,0,0,0-.62-6.38,60.91,60.91,0,0,0-1.72-7.65,61.58,61.58,0,0,0-2.75-7.35,60.56,60.56,0,0,0-3-5.68c-.45-.79-.92-1.47-1.31-2.09s-.74-1.13-1-1.55a8.92,8.92,0,0,1-.87-1.34,9.34,9.34,0,0,1,1,1.22c.32.4.71.9,1.11,1.51s.91,1.27,1.38,2.06a53.5,53.5,0,0,1,3.1,5.67A53.64,53.64,0,0,1,200,194.9a52.68,52.68,0,0,1,.52,6.44c0,.92,0,1.75,0,2.48s0,1.35-.1,1.87A8.32,8.32,0,0,1,200.18,207.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.7,278.11a9.15,9.15,0,0,1-2.26-1,26.45,26.45,0,0,1-8.92-7.77,8.88,8.88,0,0,1-1.28-2.11,55.1,55.1,0,0,0,5.64,6.1A56.37,56.37,0,0,0,215.7,278.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.56,287.46a7.78,7.78,0,0,1-1.3.47,31.67,31.67,0,0,1-3.66.94,44.08,44.08,0,0,1-5.55.8,50.29,50.29,0,0,1-6.86,0,51.07,51.07,0,0,1-6.8-1,45.35,45.35,0,0,1-5.39-1.53,32.39,32.39,0,0,1-3.49-1.42,7.26,7.26,0,0,1-1.23-.64,7,7,0,0,1,1.31.46c.82.33,2,.77,3.53,1.25a50,50,0,0,0,5.37,1.41,53.89,53.89,0,0,0,6.74.91,53,53,0,0,0,6.79,0,50.51,50.51,0,0,0,5.51-.68c1.56-.28,2.81-.55,3.67-.77A7.83,7.83,0,0,1,240.56,287.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.59,237.45a2.87,2.87,0,0,1,.08.49c0,.31.1.79.12,1.4a30.19,30.19,0,0,1-.16,5.17,32.91,32.91,0,0,1-19.36,26.43,29.93,29.93,0,0,1-4.89,1.72c-.59.16-1.06.24-1.37.3a1.78,1.78,0,0,1-.49.07s.65-.21,1.81-.57a35.41,35.41,0,0,0,4.78-1.85,34.26,34.26,0,0,0,19.48-31.27A15.29,15.29,0,0,1,267.59,237.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.17,202.5a4.8,4.8,0,0,1,0,.87l-.12,2.5c-.07,1.08-.11,2.41-.13,3.95s-.07,3.29,0,5.23c0,3.88.22,8.49.53,13.6s.88,10.73,1.54,16.61c1.35,11.77,2.9,22.38,3.92,30.07.51,3.85.91,7,1.16,9.12.12,1.05.21,1.87.28,2.49a4.73,4.73,0,0,1,.06.87,6.07,6.07,0,0,1-.17-.86c-.09-.61-.21-1.43-.37-2.47-.32-2.2-.77-5.29-1.33-9.09-1.11-7.69-2.71-18.29-4.07-30.07-.66-5.89-1.17-11.51-1.5-16.63s-.47-9.76-.42-13.64c0-1.94.05-3.7.12-5.24s.11-2.87.22-3.95.16-1.88.21-2.5A5.82,5.82,0,0,1,275.17,202.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.36,176.07a5.3,5.3,0,0,1-1.25.37,17.38,17.38,0,0,1-3.53.4,22.07,22.07,0,0,1-5.25-.57,36,36,0,0,1-6.14-2A58.69,58.69,0,0,1,223,168.5c-1.23-.85-2.21-1.55-2.89-2.05a6.22,6.22,0,0,1-1-.82,6.91,6.91,0,0,1,1.13.65l3,1.91a69.13,69.13,0,0,0,10.18,5.59,40.1,40.1,0,0,0,6,2,24.12,24.12,0,0,0,5.15.66A36.14,36.14,0,0,0,249.36,176.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.65,257.62a54.52,54.52,0,0,1,1.16-7.54,55.68,55.68,0,0,1,1.67-7.44,55,55,0,0,1-1.16,7.54A56.64,56.64,0,0,1,289.65,257.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M243,272.61a40.94,40.94,0,0,1-8.42,1.76,5.08,5.08,0,0,1-3.63-.62,3.24,3.24,0,0,1-.82-3.68,5.33,5.33,0,0,1,2.84-2.74c4.39-2,10,.14,14.12-2.45,2-1.3,3.25-3.55,4.7-5.5a22.94,22.94,0,0,1,9.74-7.54,2.45,2.45,0,0,1,1.71-.22c1.24.47,1,2.3.41,3.49-4.16,8.82-11.09,15.59-20.65,17.5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M274.94,217.8c6,14.61,3.87,31.92,11.58,45.7,1.46,2.62,3.3,5.17,3.64,8.14s-1.61,6.5-4.6,6.48a5.48,5.48,0,0,1-4.64-2.79c-.85-1.65-.78-3.77-1-5.61-1.3-11.28-3.17-22.58-4.21-33.89-.55-6-.37-12-.85-18"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M220.32,166.52a58.93,58.93,0,0,0,16.08,13.14,16.07,16.07,0,0,0,4.75,1.94,6.69,6.69,0,0,0,5-.82,3.16,3.16,0,0,0,1.37-1.75,1.85,1.85,0,0,0-.68-2,3.14,3.14,0,0,0-1.52-.33c-9-.49-17.7-5.21-25-10.18"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M228.3,171.35a8.08,8.08,0,0,1,.31-8.29,24.05,24.05,0,0,0-.78,4.12A24.06,24.06,0,0,0,228.3,171.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.42,175.46c-.15,0,.31-2,.25-4.52s-.6-4.45-.45-4.5a12.13,12.13,0,0,1,.2,9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.56,177.14c-.14-.06.47-1.58.58-3.55s-.29-3.56-.14-3.6a6.12,6.12,0,0,1,.66,3.63A6,6,0,0,1,245.56,177.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,167.31a4.51,4.51,0,0,1-.82-3.4,4.39,4.39,0,0,1,.83-2.41,1.06,1.06,0,0,1,.72-.4c.2,0,.3.06.29.09s-.41,0-.72.54a5.33,5.33,0,0,0-.6,2.22A15.92,15.92,0,0,0,221.42,167.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.56,126.87a10.44,10.44,0,0,1,4.06-2.33,10.61,10.61,0,0,1,4.6-.87c0,.16-2,.47-4.42,1.35S164.65,127,164.56,126.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,221.81l-.84-.2-2.41-.59c-1-.27-2.32-.59-3.81-.92s-3.18-.75-5.07-1.12c-3.76-.82-8.26-1.65-13.29-2.45s-10.57-1.48-16.42-2-11.44-.77-16.52-.89-9.67,0-13.52.09c-1.92,0-3.66.16-5.18.23s-2.84.16-3.92.24l-2.47.17c-.56,0-.86,0-.86,0s4.73-.52,12.43-.82c3.84-.17,8.43-.22,13.52-.14s10.68.37,16.54.87,11.4,1.24,16.43,2,9.53,1.66,13.29,2.49C269.47,220.47,274,221.81,274,221.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.79,251.54s-.23,0-.68-.09l-1.92-.27c-.84-.14-1.87-.25-3.06-.39s-2.55-.29-4.05-.42c-6-.57-14.37-.93-23.6-.9s-17.57.42-23.6.82c-3,.19-5.46.38-7.14.52l-1.94.16-.68,0,.67-.08,1.94-.2c1.68-.16,4.12-.38,7.14-.59,6-.43,14.38-.84,23.61-.88s17.59.36,23.61,1S265.79,251.54,265.79,251.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.79,257.56a3.44,3.44,0,0,1-.56,0l-1.51-.09-5-.39-5-.45-1.5-.16-.55-.09a2.68,2.68,0,0,1,.56,0l1.5.1,5,.39,5,.45,1.5.16A2.21,2.21,0,0,1,277.79,257.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.34,291.26l-.81-.16c-.53-.1-1.3-.29-2.31-.44a57.87,57.87,0,0,0-8.63-.77,122.06,122.06,0,0,0-12.83.56c-4.82.42-10.11,1-15.69,1.3a189.7,189.7,0,0,1-28.6-.63c-7.29-.74-11.75-1.57-11.75-1.57l.82.1,2.33.33c2,.27,5,.65,8.62,1a194.38,194.38,0,0,0,28.56.57c5.58-.28,10.87-.87,15.7-1.28a115.85,115.85,0,0,1,12.85-.51,55.09,55.09,0,0,1,8.63.83c1,.16,1.78.36,2.31.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,197.69l-.89-.25-2.53-.75-9.31-2.77c-7.87-2.32-18.77-5.44-30.85-8.71s-23.07-6.05-31-8l-9.43-2.31-2.57-.62-.89-.23.9.19,2.57.58,9.46,2.24c8,1.93,19,4.69,31.06,8s23,6.41,30.83,8.77l9.29,2.83,2.52.79C279.67,197.58,280,197.69,280,197.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.3,181.66l-.18.06-.51.15-1.89.5L188.45,184c-1.22.32-2.4.58-3.45.88a8.1,8.1,0,0,0-2.59,1.21,4.69,4.69,0,0,0-1.62,2,2.19,2.19,0,0,1,.25-.68,4.62,4.62,0,0,1,1.28-1.49,8.16,8.16,0,0,1,2.63-1.27c1.05-.32,2.22-.59,3.45-.9l6.28-1.53,1.91-.44.52-.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.27,147.71l-.33,0-.93.08c-.8,0-2,.18-3.4.38a52.07,52.07,0,0,0-21,7.86c-1.21.79-2.18,1.46-2.82,2l-.75.55a1.18,1.18,0,0,1-.27.18,37.33,37.33,0,0,1,3.76-2.8,49.5,49.5,0,0,1,21.05-7.88A39,39,0,0,1,188.27,147.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.87,118.68a1,1,0,0,1-.25-.15l-.7-.46c-.59-.42-1.49-1-2.61-1.64a37.65,37.65,0,0,0-9.37-3.84,35.74,35.74,0,0,0-10.07-1.06c-1.3,0-2.36.13-3.08.23l-.83.1h-.29a28.42,28.42,0,0,1,4.19-.49,34.41,34.41,0,0,1,10.13,1,35.94,35.94,0,0,1,9.39,3.93A31.13,31.13,0,0,1,173.87,118.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.37,88.88s-.06,0-.16-.14l-.43-.45c-.36-.39-.92-.93-1.64-1.57a28.12,28.12,0,0,0-6.18-4.2,28.46,28.46,0,0,0-7.08-2.41c-.94-.18-1.71-.3-2.24-.35l-.62-.08-.21,0s.07,0,.22,0l.62,0a20.34,20.34,0,0,1,2.26.3,26.61,26.61,0,0,1,7.14,2.36,26.94,26.94,0,0,1,6.19,4.28,19.22,19.22,0,0,1,1.6,1.63l.4.47C177.34,88.82,177.38,88.88,177.37,88.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.27,233.51a3.65,3.65,0,0,1-.59.07c-.38,0-.92.08-1.59.18a22.45,22.45,0,0,0-9.74,3.85c-.55.39-1,.72-1.28,1a3.57,3.57,0,0,1-.48.36,2.46,2.46,0,0,1,.43-.42,14,14,0,0,1,1.25-1,21,21,0,0,1,4.65-2.57,20.44,20.44,0,0,1,5.15-1.31,14.2,14.2,0,0,1,1.61-.11A2.46,2.46,0,0,1,290.27,233.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.37,255.87a16.88,16.88,0,0,1-3.24-1.63,21.22,21.22,0,0,1-3.12-2.42,24.26,24.26,0,0,1-3.13-3.69,23,23,0,0,1-2.25-4.28,20.72,20.72,0,0,1-1.08-3.8,16.58,16.58,0,0,1-.31-3.62,1.08,1.08,0,0,1,0,.25c0,.23,0,.46.05.72s.05.7.12,1.14a14.51,14.51,0,0,0,.24,1.48,21.65,21.65,0,0,0,1.12,3.76,24.22,24.22,0,0,0,2.24,4.24,24.9,24.9,0,0,0,3.09,3.66,22.47,22.47,0,0,0,3.07,2.43,13,13,0,0,0,1.29.78,7.75,7.75,0,0,0,1,.53l.64.32C312.3,255.82,312.38,255.86,312.37,255.87Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Starts--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.42,171.11l.32,1a1.48,1.48,0,0,0,1,1l1,.32-1,.36a1.45,1.45,0,0,0-.91.9l-.37,1.06-.41-1.11a1.47,1.47,0,0,0-.91-.88l-1-.33,1-.33a1.46,1.46,0,0,0,.89-.86Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.09,124l.33,1a1.44,1.44,0,0,0,1,1l1,.32-1,.36a1.48,1.48,0,0,0-.91.9l-.37,1.06-.4-1.1a1.48,1.48,0,0,0-.92-.89l-1-.33,1-.33a1.44,1.44,0,0,0,.89-.85Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.53,328l.32,1a1.44,1.44,0,0,0,1,1l1,.32-1,.36a1.48,1.48,0,0,0-.91.9l-.36,1.06-.41-1.1a1.48,1.48,0,0,0-.92-.89l-1-.33,1-.33a1.47,1.47,0,0,0,.9-.86Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.09,295.09l.33,1a1.44,1.44,0,0,0,1,1l1,.32-1,.36a1.48,1.48,0,0,0-.91.9l-.37,1.06-.4-1.1a1.48,1.48,0,0,0-.92-.89l-1-.33,1-.33a1.44,1.44,0,0,0,.89-.85Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,130.53l1.32,4.23a6,6,0,0,0,3.94,4l4.25,1.32-4.27,1.46a6,6,0,0,0-3.74,3.71l-1.5,4.34L440.28,145a6,6,0,0,0-3.75-3.62L432.44,140l4-1.36a6,6,0,0,0,3.66-3.51Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.26,374.21l1.31,4.24a6,6,0,0,0,3.95,3.95l4.24,1.32-4.26,1.45a6,6,0,0,0-3.74,3.72l-1.5,4.34-1.68-4.53a6,6,0,0,0-3.74-3.63l-4.09-1.35,4-1.36a6,6,0,0,0,3.67-3.51Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.77,169.43l.54,1.75a2.5,2.5,0,0,0,1.63,1.63l1.75.54-1.76.6a2.5,2.5,0,0,0-1.54,1.54l-.62,1.79-.69-1.87a2.51,2.51,0,0,0-1.55-1.5l-1.69-.56,1.67-.56a2.49,2.49,0,0,0,1.51-1.45Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.87,365.48l.54,1.75a2.47,2.47,0,0,0,1.63,1.62l1.75.55L375,370a2.48,2.48,0,0,0-1.54,1.54l-.62,1.79-.69-1.88a2.49,2.49,0,0,0-1.55-1.49l-1.69-.56,1.67-.56a2.49,2.49,0,0,0,1.51-1.45Z",
    style: {
      fill: "#00CCAA"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Medal--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.31,257.55c0,1-24.64,83.68-24.64,83.68l21.18-9.47,11.6,25.57,14.91-98.49Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.34 261.05 373.36 355.88 391.81 329.87 415.64 346.92 391.81 253.78 368.34 261.05",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M348.71,263.82a9.1,9.1,0,0,0,8.12,6.37c2.17.09,4.56-.58,6.39.6s2.6,3.93,4.75,4.22c2.52.36,4-3,6.38-3.8,3.25-1.06,6.66,2.86,9.86,1.65,2.06-.78,3-3.43,5.18-4a7.19,7.19,0,0,1,2.88.1,5.65,5.65,0,0,0,3.26-.62l-1.17-4.57-2-8.87H349.52Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M373.76,190a28.19,28.19,0,0,1,6.19,1.24,2.6,2.6,0,0,1,.19-1q2.72-7.28,5.42-14.53l.13-.12a4.67,4.67,0,0,1-1.79-1.8,5.65,5.65,0,0,0-4.87-2.6c-1,4.12-2.19,9.76-3.07,13.27A15.84,15.84,0,0,1,373.76,190Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.66,234.16a28.59,28.59,0,0,1-3.22-6.42,2.34,2.34,0,0,1-1,.58l-.43.15a6,6,0,0,1-.84.45,26.26,26.26,0,0,1-2.78.89l-3.42.95c-2.43.66-4.64,1.23-6.24,1.61a13.84,13.84,0,0,1-2.62.53,13.34,13.34,0,0,1,2.52-.88l2.18-.64-5,1.11c-.65,2.84-2.66,5.88-.89,8.07a3,3,0,0,0,.65.58c6.37-2.36,14.54-5.41,19.89-6.82A3.55,3.55,0,0,1,347.66,234.16Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.06,189.27c0,.28,0,.52,0,.74s0,.52,0,.77a28.57,28.57,0,0,1,7-.91c0-.13,0-.26,0-.39l.33-5.26c0-.35,0-.71,0-1.08.07-3.78.22-6.91.35-7.52-1.06-1.25-2.07-3.87-4.21-4.15-1.77-.23-2.69,0-3.44.72C364.17,177.45,364,184.1,364.06,189.27Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.43,207.7q.66.26,1.32.48c-1.87-.74-3.79-1.54-5.63-2.33C333.39,206.44,334.84,207.08,336.43,207.7Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.86,216.89A28.41,28.41,0,0,1,344,210.4c-.56-.17-1.14-.36-1.73-.56a29.44,29.44,0,0,1-6-1.66,56.45,56.45,0,0,1-6.35-3c-1.1-.59-1.88-1-2.25-1.29l-1.2-.51c-.78,1.27-2,2.31-2.85,3.58a4.59,4.59,0,0,0-.71,2.41c6.51,1.78,14.37,4.13,19.84,7.39Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.06,207.24a28,28,0,0,1,3-5.33l-.43-.28a50.7,50.7,0,0,1-9-7.63l-.07-.08c-1.22-1-2.38-2.07-3.41-3a3,3,0,0,1-.69,1.17c-1.55,1.55-4.46.55-6.17,1.92a3.09,3.09,0,0,0-1.09,2,170.94,170.94,0,0,1,15.77,9.92C343.79,206.44,344.52,206.89,345.06,207.24Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.78,197.39c.7,1,1.32,1.86,1.78,2.54a28.49,28.49,0,0,1,5.31-4.86c-.6-.76-1.34-1.75-2.16-2.85-.73-.84-1.56-1.84-2.43-2.93-1.28-1.61-2.38-3.1-3.14-4.21a8.59,8.59,0,0,1-1.13-1.86s.31.26.74.79c-.7-1-1.36-1.85-1.94-2.61a5.33,5.33,0,0,1-1.92,2.27c-1.26.75-2.93.71-4.36,1a107.42,107.42,0,0,1,8,10.92Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.64,193.91a27.86,27.86,0,0,1,5.18-2.43c-.07-.21-.13-.43-.2-.68-.39-1.35-.86-3.23-1.27-5.34s-.68-4-.83-5.42a17.13,17.13,0,0,1-.14-2.17l-.06-.39a5.07,5.07,0,0,1-3.72-1.21c-1.65-1.48-4.45-1.29-6.61-.36,2.28,5.49,5.69,13,7.57,17.81C356.59,193.78,356.61,193.84,356.64,193.91Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.31,200.22l-.07-.08.06.1Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.94,226.17a28.91,28.91,0,0,1-1.09-6.88h-.16c-2,.11-4.34.08-6.8,0-.75,0-1.52,0-2.34,0-2.38,0-4.53-.19-6.08-.34-.71-.07-1.28-.14-1.7-.2l-1.52-.09c-.34.52-.68,1-1,1.58-.87,1.53-1.42,3.45-.6,5l.09.13q9.93.24,19.84.58A3.54,3.54,0,0,1,343.94,226.17Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.23,240.88l.42-.27a28.8,28.8,0,0,1-5-5.13,2.4,2.4,0,0,1-.78.84,1.86,1.86,0,0,1-.56.77c-1.28,1-3.08,2.11-5.09,3.43s-3.83,2.44-5.17,3.25a12,12,0,0,1-2.22,1.22,12.51,12.51,0,0,1,2-1.53c.74-.5,1.64-1.12,2.65-1.78-1.94,1.17-3.89,2.34-5.64,3.41.33,1.48-.19,3.2.49,4.59s2.08,1.8,3.64,2.08l11.9-8.84A14.63,14.63,0,0,1,353.23,240.88Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.57,245.48l1.63,1.28a1,1,0,0,1,.1-.11l-.53-.35Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.72,236.93a28.6,28.6,0,0,1-5.09,4.61,16.88,16.88,0,0,1,1.47,1.72,1.67,1.67,0,0,1,.16.12,10.66,10.66,0,0,1,2,2.76l2.06,3.51.06.12c1.34,2.23,2.68,4.55,3.86,6.57a3.28,3.28,0,0,1,.59-.89c2.08-2.17,6.3-.06,8.5-2.09a3.38,3.38,0,0,0,.56-.7c-4.05-4.41-9.45-10.59-12.89-14.2A9.54,9.54,0,0,1,392.72,236.93Zm1.59,4.74a35.49,35.49,0,0,1,2.48,3.57,37.63,37.63,0,0,1,2.47,3.58,12.36,12.36,0,0,1-2.9-3.28A12.8,12.8,0,0,1,394.31,241.67Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,175.8a.46.46,0,0,1-.07-.07,4.58,4.58,0,0,1,0,.49Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.5,221.59a28.31,28.31,0,0,1-1.37,6l.78.38,2.76,1.44a18.26,18.26,0,0,1-2.68-1.66,84.58,84.58,0,0,1,8.45,4.24c2,1.09,3.9,2.12,5.33,2.93l.93.39a4.05,4.05,0,0,1,.2-1.38c.78-2.25,3.66-3.43,4.65-5.41C412.51,226.31,404.75,223.56,399.5,221.59Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.06,235.29c.55.43,1.25,1,2,1.54l.27.19c1.65,1.11,3.89,2.67,6.35,4.42s4.67,3.37,6.26,4.55l.6.46c1-.72,2.2-1.17,3.24-1.79-5.14-4.5-11.21-10.72-15.83-14.26A29,29,0,0,1,394.06,235.29Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5,245.46a5.08,5.08,0,0,0-.31-.57,28.28,28.28,0,0,1-5.21-2.63l-.14.18c-.37.45-.79.93-1.25,1.44-.82,1-1.94,2.29-3.23,3.68s-2.67,2.75-3.63,3.66a8.29,8.29,0,0,1-1.64,1.37s.09-.19.32-.46c-.82.82-1.59,1.62-2.29,2.37,1.1,2.29,0,5.63,1.88,7.48a3.24,3.24,0,0,0,1.17.75c4-5.37,9.45-12.32,13.33-16.63A1.66,1.66,0,0,1,361.5,245.46Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.9,246.68a2.37,2.37,0,0,1,.45,1.31,6.16,6.16,0,0,1,.2,3.06c-.15,1.21-.32,2.51-.49,3.87-.24,1.81-.48,3.5-.69,5-.16,1.91-.31,3.79-.48,5.49a13.4,13.4,0,0,0,3.46,2.35c1.92.62,3.63-.31,5.33-1.55-.39-6.41-.73-14.4-.47-20.1l.3.7c-.09-.33-.12-.52-.09-.53a10.39,10.39,0,0,1,.95,2.27c.52,1.43,1.18,3.43,1.84,5.65q.27.93.51,1.8c.7,2.37,1.31,4.76,1.77,7a5.27,5.27,0,0,1,2.25-.46c1.76.05,3.62,1.1,5.28,1.32-2.82-6.83-5.83-15.38-7-21.22A28.36,28.36,0,0,1,372.9,246.68Zm3.63,10.87a10.07,10.07,0,0,1-.22-2.8,10.69,10.69,0,0,1,.05-2.81,10.42,10.42,0,0,1,.17,5.61Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.17,246.8a.52.52,0,0,1,.11-.1,28.07,28.07,0,0,1-8.87-1.73c.07.09.15.19.24.32a1.74,1.74,0,0,0,.1.19c.58.16.76,1,.69,1.63a7.54,7.54,0,0,1-.16.93,8.43,8.43,0,0,1-.59,2.59c-.44,1.15-1,2.34-1.64,3.6a66.08,66.08,0,0,1-3.52,6.22c-.59.92-1.07,1.6-1.37,2a4.33,4.33,0,0,1,1.06.26c2.79,1.09,4.3,5.14,7.27,4.79l.27-.05c1.74-5.54,3.48-13.22,5.22-18.37A5.84,5.84,0,0,1,370.17,246.8Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.86,202.44q.5-.45,1-.87a5.27,5.27,0,0,1,1.32-1.3c.79-.56,1.67-1.11,2.61-1.68,1.87-1.14,3.61-2.08,4.9-2.72.88-.43,1.53-.72,1.87-.84l1.78-1.05,0,0c-1.76-2.76.52-6.95-1.55-9.49a3.14,3.14,0,0,0-.31-.32c-5.21,3.86-11.93,8.24-17.78,11.7A28.46,28.46,0,0,1,394.86,202.44Zm1.25-11.18a30.64,30.64,0,0,1,3.71-2.3,13.48,13.48,0,0,1-3.43,2.74,13.89,13.89,0,0,1-3.91,2A30.32,30.32,0,0,1,396.11,191.26Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.32,213.7a28.91,28.91,0,0,1,.37,4.59c0,.29,0,.57,0,.85h.47c.84,0,1.67.08,2.51.14l.59,0c1.72,0,4.09.16,6.71.35,2.45.19,4.67.41,6.34.61.42-1.89,2.75-2.83,3.44-4.66a3.87,3.87,0,0,0-.2-2.87c-6.11.34-14.37.84-19.46,1Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.38,178.32l-10.14,12.75a3.58,3.58,0,0,1-.75.7,28,28,0,0,1,6.29,3.39l.14-.18h0a3,3,0,0,1,.62-1c.45-.52,1-1.13,1.58-1.79,3-3.6,6.42-7.24,9.28-10.26a4.33,4.33,0,0,1-1.56-1c-1.26-1.27-1.53-3.39-3-4.36a3.45,3.45,0,0,0-1.57-.5.45.45,0,0,1,0,.11A3,3,0,0,1,392.38,178.32Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.66,210.71l.83-.37a13,13,0,0,1,1.95-.88c1.24-.51,3-1.17,4.88-1.87s3.66-1.31,4.93-1.73a9.35,9.35,0,0,1,2.1-.57s-.24.18-.72.39l2.58-.85c0-2.08.58-4.29-.48-6.06a4.31,4.31,0,0,0-1-1.13c-5.45,2.2-12.9,5.66-17.68,6.66A28.21,28.21,0,0,1,398.66,210.71Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.23,220.68v0l-2.23-.17C414.74,220.56,415.48,220.62,416.23,220.68Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,190.71c.06.24.1.46.14.66l.16-.05c-.14-.36-.28-.75-.42-1.18C361.89,190.33,361.94,190.54,362,190.71Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.81,183.16h0Z",
    style: {
      fill: "#00CCAA"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M387.86,195.22a1.05,1.05,0,0,1,.06-.24l-.14.18Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M395.34,203.18a2.6,2.6,0,0,1,.18-.94,2.92,2.92,0,0,1,.36-.67q-.53.42-1,.87C395,202.68,395.18,202.93,395.34,203.18Z",
    style: {
      fill: "#00CCAA"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M413.7,235.45v-.14l-.93-.39Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M396.1,236.83c-.79-.59-1.49-1.11-2-1.54l-.12.15C394.32,235.66,395.08,236.15,396.1,236.83Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M396.92,256.09l.22.41.06-.16c-1.18-2-2.52-4.34-3.86-6.57C394.76,252.22,396,254.46,396.92,256.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M372.32,246.7a2.81,2.81,0,0,1,1,1.11c0,.06,0,.12.07.18a2.37,2.37,0,0,0-.45-1.31Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.75,245.48a4.54,4.54,0,0,1,.53,1.93,4.42,4.42,0,0,1,0,.63,7.54,7.54,0,0,0,.16-.93C362.51,246.47,362.33,245.64,361.75,245.48Z",
    style: {
      fill: "#00CCAA"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M356,242.26l-.1,0c-.18.28-.57.8-1.12,1.47-.05.06-.11.14-.17.2.46-.51.88-1,1.25-1.44Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M344.15,209.72a2.31,2.31,0,0,1-1.1.24l-.83-.12c.59.2,1.17.39,1.73.56C344,210.17,344.08,210,344.15,209.72Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M355.22,194.82a9.69,9.69,0,0,1-1.55-1.52l-1-1.08c.82,1.1,1.56,2.09,2.16,2.85Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M364,190.81l.09,0c0-.25,0-.51,0-.77A3.66,3.66,0,0,1,364,190.81Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M371.1,189.87h.38c-.05-1.13-.06-3.21,0-5.65l-.33,5.26C371.11,189.61,371.1,189.74,371.1,189.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380.14,190.23a2.6,2.6,0,0,0-.19,1c.52.17,1,.35,1.54.55a3.58,3.58,0,0,0,.75-.7l10.14-12.75a3,3,0,0,0,.9-2.11.45.45,0,0,0,0-.11c-1.83-.15-3.93.76-5.76.19a13.59,13.59,0,0,1-1.29-.45c-.52,1.57-1.38,4-2.39,6.68a81.44,81.44,0,0,1-3.42,8.38,78.39,78.39,0,0,1,2.93-8.56c1-2.71,1.95-5.11,2.59-6.64a1.55,1.55,0,0,1-.22-.12l-.13.12Q382.85,183,380.14,190.23Zm5.28-4.18a25.59,25.59,0,0,1,2.94-3.49,16.3,16.3,0,0,1-2.53,3.81,16.74,16.74,0,0,1-3.11,3.36A25.58,25.58,0,0,1,385.42,186.05Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.8,189.25c1.69-1.83,3.24-3.47,4.38-4.64a12.67,12.67,0,0,1,1.93-1.82,13.72,13.72,0,0,1-1.66,2.07c-1.07,1.23-2.58,2.91-4.26,4.74s-3.24,3.48-4.38,4.64a2,2,0,0,0-.69,1.16l.57.44c5.85-3.46,12.57-7.84,17.78-11.7a4.29,4.29,0,0,0-1.63-1h0c-1.68-.58-3.75-.56-5.41-1.21-2.86,3-6.3,6.66-9.28,10.26C390.92,191.31,391.83,190.31,392.8,189.25Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.85,195a11.33,11.33,0,0,1-2,1.24c-1.23.72-2.94,1.7-4.8,2.83s-3.69,2.07-4.22,3.35a2.63,2.63,0,0,0-.24,1.24l.39.68c4.78-1,12.23-4.46,17.68-6.66-1.66-1.33-4.15-1.85-5.33-3.66L406.58,195C406.74,195,406.84,194.94,406.85,195Zm-3.51,6a11,11,0,0,1-2.89,1.07,14,14,0,0,1,5.63-2.47A10.72,10.72,0,0,1,403.34,200.92Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.39,206.21c-1.24.5-3,1.16-4.89,1.87s-3.67,1.31-4.94,1.72a8.59,8.59,0,0,1-2.09.57l0,0-.83.37a28.84,28.84,0,0,1,.66,3h.75c5.09-.13,13.35-.63,19.46-1a8.74,8.74,0,0,0-1.18-2c-1.09-1.37-2.44-2.63-2.92-4.31a6.5,6.5,0,0,1-.22-1.65l-2.58.85Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.91,220.18l-6.69-.51a16.18,16.18,0,0,1-2.77-.32,10.88,10.88,0,0,1,2.2-.06c-.84-.06-1.67-.11-2.51-.14h-.47c0,.83-.08,1.64-.17,2.45,5.25,2,13,4.72,19.05,6.93a3,3,0,0,0,.34-1.31c.07-2.39-2.81-4.22-2.66-6.53-.75-.06-1.49-.12-2.23-.2Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.67,229.41,398.91,228l-.78-.38A27.52,27.52,0,0,1,397,230.4c4.62,3.54,10.69,9.76,15.83,14.26a4.38,4.38,0,0,0,1.59-1.49c1.24-2.18-.45-4.83-.69-7.33-1.55-.77-3.9-2-6.52-3.39C405.06,231.3,403.12,230.23,401.67,229.41Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.42,241.87c-2.46-1.75-4.68-3.37-6.26-4.55-1.13-.85-1.94-1.47-2.29-1.79-.37.48-.75.95-1.15,1.4a9.54,9.54,0,0,0,1.24,1.53c3.44,3.61,8.84,9.79,12.89,14.2.94-1.56.71-3.83,1.84-5.36a3.71,3.71,0,0,1,.51-.54l-1.63-1.28C406.11,244.47,404.33,243.23,402.42,241.87Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.83,249.91c-.72-1.24-1.4-2.43-2-3.53a11.63,11.63,0,0,0-1.77-2.72,1.9,1.9,0,0,0-1.93-.43c-.47.17-.6.48-.64.44s0-.35.55-.63a2.09,2.09,0,0,1,2.09.22,16.88,16.88,0,0,0-1.47-1.72c-.52.36-1.05.72-1.59,1.05,1.15,5.84,4.16,14.39,7,21.22a3,3,0,0,0,2.32-.53c1.78-1.36,1.05-4.22,1.66-6.36l-.4-.64C395.61,254.66,394.27,252.41,392.83,249.91Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.72,259.9a10.78,10.78,0,0,1,.43,2.43,12.7,12.7,0,0,1-.78-2.33l-1.66-5.69c-.63-2.12-1.2-4.05-1.69-5.68-.23-.81-.41-1.45-.51-1.86l-.3-.7c-.26,5.7.08,13.69.47,20.1a25.74,25.74,0,0,1,4.81-3.22c-.46-2.23-1.07-4.62-1.77-7C384.14,257.47,384.48,258.83,384.72,259.9Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.05,261.92a16.46,16.46,0,0,1-.56,2.88,15.4,15.4,0,0,1,.2-2.93c.19-1.8.49-4.28.85-7l.54-3.86a5.89,5.89,0,0,0-.13-3,2.69,2.69,0,0,0-1.09-1.25l-.6,0c-.33,0-.66,0-1,0a.52.52,0,0,0-.11.1,5.84,5.84,0,0,0-1.19,2.29c-1.74,5.15-3.48,12.83-5.22,18.37,2.06-.43,3.39-2.94,5.52-3.08a3.94,3.94,0,0,1,2.61,1c.17-1.7.32-3.58.48-5.49C372.26,260.63,372.15,261.32,372.05,261.92Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.59,254c.61-1.24,1.21-2.44,1.66-3.53a8,8,0,0,0,.66-3,4.93,4.93,0,0,0-.41-2,1.66,1.66,0,0,0-1,.64c-3.88,4.31-9.35,11.26-13.33,16.63,2.2.83,5.22-.58,7.81-.3.24-.44.67-1.18,1.24-2.17C357.12,258.68,358.35,256.48,359.59,254Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.41,252.13c.7-.83,2.5-2.7,4.57-4.93,2.25-2.41,4.13-4.47,4.78-5.07-.65-.43-1.28-.88-1.9-1.35a30.59,30.59,0,0,1-2.49,2.1,14.37,14.37,0,0,1-3.12,2.1,13.22,13.22,0,0,1,2.8-2.51c.84-.65,1.61-1.21,2.18-1.59a14.63,14.63,0,0,0-3.38,2L338,251.76c2.06.36,4.39.45,5.68,2a3.71,3.71,0,0,1,.49.77C344.82,253.75,345.59,253,346.41,252.13Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.9,240.08c2-1.3,3.87-2.43,5.13-3.27a1.63,1.63,0,0,0,.58-.74,1,1,0,0,0,0-.7c-.13-.39-.4-.46-.38-.5s.33,0,.57.42a1.25,1.25,0,0,1,.09.86.7.7,0,0,1-.06.17,2.4,2.4,0,0,0,.78-.84c-.32-.43-.64-.87-.95-1.32a3.55,3.55,0,0,0-1.2.16c-5.35,1.41-13.52,4.46-19.89,6.82,2,1.46,5.65.83,6.94,3.08a3.48,3.48,0,0,1,.31.87c1.75-1.07,3.7-2.24,5.64-3.41C340.22,241.17,341,240.64,341.9,240.08Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.84,230.26l3.43-.92c1.06-.27,2-.48,2.77-.76a5.41,5.41,0,0,0,2.16-1.42s-.06.27-.37.63a3.65,3.65,0,0,1-.81.68l.43-.15a2.34,2.34,0,0,0,1-.58c-.18-.52-.35-1-.5-1.57a3.54,3.54,0,0,0-1.34-.24q-9.92-.35-19.84-.58c.92,1.56,3,2.25,3.82,3.86a4.61,4.61,0,0,1,.23,3.28l5-1.11C333,231,334.39,230.65,335.84,230.26Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,218.54a13.49,13.49,0,0,1,2.52,0c1.56.06,3.7.14,6.07.19s4.52.06,6.07.07a14,14,0,0,1,2.53.1,10.86,10.86,0,0,1-2.52.27c-1,.06-2.32.09-3.75.1,2.46.1,4.82.13,6.8,0h.16c0-.33,0-.66,0-1s0-.94,0-1.4l-.14-.09c-5.47-3.26-13.33-5.61-19.84-7.39a2.37,2.37,0,0,0,1.53,2.56l-.14-.9c1.61.7,2.05,2.87,1.54,4.55a12,12,0,0,1-1.56,3l1.52.09A2.34,2.34,0,0,1,325,218.54Zm14-1.41a11.35,11.35,0,0,1,3.29.85,11.47,11.47,0,0,1-3.38-.33,11.23,11.23,0,0,1-3.28-.85A11.37,11.37,0,0,1,339,217.13Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.39,203.74a16,16,0,0,1,2.66,1.15l2.07,1c1.84.79,3.76,1.59,5.63,2.33a30.87,30.87,0,0,0,5.32,1.41,2,2,0,0,0,1.08-.18.81.81,0,0,0,.14-.12c.2-.59.41-1.17.65-1.75-.92-.45-2.32-1.21-3.88-2.11a28.63,28.63,0,0,1-4.72-3,31.72,31.72,0,0,1,5,2.56l1.62,1A170.94,170.94,0,0,0,327.17,196c-.32,1.88.4,4.28-.18,6.23a5.52,5.52,0,0,1-.55,1.18l1.2.51C327.48,203.83,327.38,203.75,327.39,203.74Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.05,192.1a12.09,12.09,0,0,1,1.81,1.64c1.09,1,2.61,2.46,4.35,3.94s3.39,2.75,4.6,3.65l.41.31c.35-.48.7-.95,1.08-1.4l-.06-.1c-.53-.63-1.19-1.48-1.89-2.45a17.3,17.3,0,0,1-2.38-3.94,9.49,9.49,0,0,1,1.52,1.86,107.42,107.42,0,0,0-8-10.92,3.69,3.69,0,0,0-2.17,1.17c-1.11,1.35-.7,3.47-1.24,5.07,1,.92,2.19,1.94,3.41,3A9.69,9.69,0,0,1,337.05,192.1Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.69,189c2.5,3.16,4.59,5.68,4.54,5.84q.69-.47,1.41-.9c0-.07-.05-.13-.08-.19-1.88-4.8-5.29-12.32-7.57-17.81a10.56,10.56,0,0,0-1.06.55c-1.67,1-2.22,3.17-3.12,4.94.58.76,1.24,1.65,1.94,2.61S349,186.87,350.69,189Zm2.58-1.45a19.13,19.13,0,0,1,1.62,3.23,18.69,18.69,0,0,1,1.45,3.31,15.56,15.56,0,0,1-3.07-6.54Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.41,177.76a11.78,11.78,0,0,1,.48,2.23c.24,1.37.57,3.28,1,5.37.36,1.83.71,3.47,1,4.78.14.43.28.82.42,1.18.53-.18,1.07-.34,1.63-.49a25.08,25.08,0,0,1-.51-3.31,15.54,15.54,0,0,1-.34-3.38,9.08,9.08,0,0,1,.86,3.32c.09.66.13,1.28.15,1.81,0-5.17.11-11.82.1-17.08-.83.79-1.44,2.17-2.78,4.15a2.76,2.76,0,0,1-2.06,1.14l.06.39C359.39,177.81,359.4,177.76,359.41,177.76Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,183.15c-.05,2.91-.14,5.43-.25,6.72.68,0,1.36,0,2,.11a15.84,15.84,0,0,0,2.2-5.53c.88-3.51,2.09-9.15,3.07-13.27a4.32,4.32,0,0,0-1.77.51c-1.54.85-3.41,4.57-4.38,4.59a1.27,1.27,0,0,1-.9-.48l0,.42C372,177.44,372,180.08,372,183.15Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.56,209.8c1.27-.41,3-1,4.94-1.72s3.65-1.37,4.89-1.87l1.24-.53c.48-.21.74-.35.72-.39a9.35,9.35,0,0,0-2.1.57c-1.27.42-3,1-4.93,1.73s-3.64,1.36-4.88,1.87a13,13,0,0,0-1.95.88l0,0A8.59,8.59,0,0,0,401.56,209.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.24,219.31l-.59,0a10.88,10.88,0,0,0-2.2.06,16.18,16.18,0,0,0,2.77.32l6.69.51,4.09.3,2.23.17c0-.09,0-.18,0-.27s0-.07,0-.11c-1.67-.2-3.89-.42-6.34-.61C407.33,219.47,405,219.35,403.24,219.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.44,232a84.58,84.58,0,0,0-8.45-4.24,18.26,18.26,0,0,0,2.68,1.66c1.45.82,3.39,1.89,5.53,3,2.62,1.4,5,2.62,6.52,3.39,0-.13,0-.26,0-.39l-.93-.53C411.34,234.11,409.48,233.08,407.44,232Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.72,241.44c-2.46-1.75-4.7-3.31-6.35-4.42l-.27-.19c-1-.68-1.78-1.17-2.16-1.39l.12-.15A29,29,0,0,0,397,230.4a27.52,27.52,0,0,0,1.14-2.81,28.31,28.31,0,0,0,1.37-6c.09-.81.15-1.62.17-2.45,0-.28,0-.56,0-.85a28,28,0,0,0-1-7.58A28.21,28.21,0,0,0,396,204.3l-.39-.68a2.63,2.63,0,0,1,.24-1.24c.53-1.28,2.39-2.19,4.22-3.35s3.57-2.11,4.8-2.83a11.33,11.33,0,0,0,2-1.24s-.11,0-.27.07c-.34.12-1,.41-1.87.84-1.29.64-3,1.58-4.9,2.72-.94.57-1.82,1.12-2.61,1.68a5.27,5.27,0,0,0-1.32,1.3,2.92,2.92,0,0,0-.36.67,2.6,2.6,0,0,0-.18.94c-.16-.25-.31-.5-.48-.74a28.46,28.46,0,0,0-6.17-6.6l-.57-.44a2,2,0,0,1,.69-1.16c1.14-1.16,2.69-2.8,4.38-4.64s3.19-3.51,4.26-4.74a13.72,13.72,0,0,0,1.66-2.07,12.67,12.67,0,0,0-1.93,1.82c-1.14,1.17-2.69,2.81-4.38,4.64-1,1.06-1.88,2.06-2.68,3-.59.66-1.13,1.27-1.58,1.79a3,3,0,0,0-.62,1h0a1.05,1.05,0,0,0-.06.24l-.08-.06a28,28,0,0,0-6.29-3.39c-.51-.2-1-.38-1.54-.55a28.19,28.19,0,0,0-6.19-1.24c-.67-.06-1.35-.09-2-.11.11-1.29.2-3.81.25-6.72.06-3.07,0-5.71,0-6.93a4.58,4.58,0,0,0,0-.49l-.1-.11c-.13.61-.28,3.74-.35,7.52,0,.37,0,.73,0,1.08,0,2.44,0,4.52,0,5.65h-.38a28.57,28.57,0,0,0-7,.91l-.09,0a3.66,3.66,0,0,0,.08-.8c0-.22,0-.46,0-.74,0-.53-.06-1.15-.15-1.81a9.08,9.08,0,0,0-.86-3.32,15.54,15.54,0,0,0,.34,3.38,25.08,25.08,0,0,0,.51,3.31c-.56.15-1.1.31-1.63.49l-.16.05c0-.2-.08-.42-.14-.66s-.08-.38-.12-.57c-.28-1.31-.63-2.95-1-4.78-.4-2.09-.73-4-1-5.37a11.78,11.78,0,0,0-.48-2.23s0,.05,0,.11a17.13,17.13,0,0,0,.14,2.17c.15,1.39.42,3.32.83,5.42s.88,4,1.27,5.34c.07.25.13.47.2.68a27.86,27.86,0,0,0-5.18,2.43q-.72.43-1.41.9c0-.16-2-2.68-4.54-5.84-1.67-2.1-3.11-3.95-3.94-5-.43-.53-.7-.82-.74-.79a8.59,8.59,0,0,0,1.13,1.86c.76,1.11,1.86,2.6,3.14,4.21.87,1.09,1.7,2.09,2.43,2.93l1,1.08a9.69,9.69,0,0,0,1.55,1.52l-.35.25a28.49,28.49,0,0,0-5.31,4.86c-.46-.68-1.08-1.57-1.78-2.54l-1.29-1.78a9.49,9.49,0,0,0-1.52-1.86,17.3,17.3,0,0,0,2.38,3.94c.7,1,1.36,1.82,1.89,2.45l.07.08v0c-.38.45-.73.92-1.08,1.4l-.41-.31c-1.21-.9-2.85-2.17-4.6-3.65s-3.26-2.9-4.35-3.94a12.09,12.09,0,0,0-1.81-1.64,9.69,9.69,0,0,0,1.48,1.82l.07.08a50.7,50.7,0,0,0,9,7.63l.43.28a28,28,0,0,0-3,5.33c-.54-.35-1.27-.8-2.12-1.31l-1.62-1a31.72,31.72,0,0,0-5-2.56,28.63,28.63,0,0,0,4.72,3c1.56.9,3,1.66,3.88,2.11-.24.58-.45,1.16-.65,1.75a.81.81,0,0,1-.14.12,2,2,0,0,1-1.08.18,30.87,30.87,0,0,1-5.32-1.41q-.66-.23-1.32-.48c-1.59-.62-3-1.26-4.31-1.85l-2.07-1a16,16,0,0,0-2.66-1.15s.09.09.25.19c.37.25,1.15.7,2.25,1.29a56.45,56.45,0,0,0,6.35,3,29.44,29.44,0,0,0,6,1.66l.83.12a2.31,2.31,0,0,0,1.1-.24c-.07.23-.14.45-.2.68a28.41,28.41,0,0,0-1.09,6.49c0,.46,0,.93,0,1.4s0,.67,0,1a28.91,28.91,0,0,0,1.09,6.88c.15.53.32,1.05.5,1.57a28.59,28.59,0,0,0,3.22,6.42c.31.45.63.89.95,1.32a28.8,28.8,0,0,0,5,5.13l-.42.27c-.57.38-1.34.94-2.18,1.59a13.22,13.22,0,0,0-2.8,2.51,14.37,14.37,0,0,0,3.12-2.1,30.59,30.59,0,0,0,2.49-2.1c.62.47,1.25.92,1.9,1.35-.65.6-2.53,2.66-4.78,5.07-2.07,2.23-3.87,4.1-4.57,4.93-.23.27-.35.43-.32.46a8.29,8.29,0,0,0,1.64-1.37c1-.91,2.25-2.19,3.63-3.66s2.41-2.68,3.23-3.68c.06-.06.12-.14.17-.2.55-.67.94-1.19,1.12-1.47l.1,0a28.28,28.28,0,0,0,5.21,2.63,5.08,5.08,0,0,1,.31.57,4.93,4.93,0,0,1,.41,2,8,8,0,0,1-.66,3c-.45,1.09-1.05,2.29-1.66,3.53-1.24,2.49-2.47,4.69-3.37,6.27-.57,1-1,1.73-1.24,2.17l.18,0c.3-.41.78-1.09,1.37-2a66.08,66.08,0,0,0,3.52-6.22c.62-1.26,1.2-2.45,1.64-3.6a8.43,8.43,0,0,0,.59-2.59,4.42,4.42,0,0,0,0-.63,4.54,4.54,0,0,0-.53-1.93,1.74,1.74,0,0,1-.1-.19c-.09-.13-.17-.23-.24-.32a28.07,28.07,0,0,0,8.87,1.73c.32,0,.65,0,1,0l.6,0A2.69,2.69,0,0,1,373,248a5.89,5.89,0,0,1,.13,3l-.54,3.86c-.36,2.74-.66,5.22-.85,7a15.4,15.4,0,0,0-.2,2.93,16.46,16.46,0,0,0,.56-2.88c.1-.6.21-1.29.32-2,.21-1.46.45-3.15.69-5,.17-1.36.34-2.66.49-3.87a6.16,6.16,0,0,0-.2-3.06c0-.06,0-.12-.07-.18a2.81,2.81,0,0,0-1-1.11l.58,0A28.36,28.36,0,0,0,386,242.59c.54-.33,1.07-.69,1.59-1.05a28.6,28.6,0,0,0,5.09-4.61c.4-.45.78-.92,1.15-1.4.35.32,1.16.94,2.29,1.79,1.58,1.18,3.8,2.8,6.26,4.55,1.91,1.36,3.69,2.6,5.15,3.61l1.2.82.53.35.28-.2L409,246C407.39,244.81,405.18,243.2,402.72,241.44Zm-31.46,1.78a24.93,24.93,0,1,1,24.93-24.93A24.93,24.93,0,0,1,371.26,243.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.26,248.82a37.63,37.63,0,0,0-2.47-3.58,35.49,35.49,0,0,0-2.48-3.57,12.8,12.8,0,0,0,2.05,3.87A12.36,12.36,0,0,0,399.26,248.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.34,249.77l-.06-.12-2.06-3.51a10.66,10.66,0,0,0-2-2.76,1.67,1.67,0,0,0-.16-.12A2.09,2.09,0,0,0,387,243c-.51.28-.57.64-.55.63s.17-.27.64-.44a1.9,1.9,0,0,1,1.93.43,11.63,11.63,0,0,1,1.77,2.72c.63,1.1,1.31,2.29,2,3.53,1.44,2.5,2.78,4.75,3.77,6.37l.4.64c0-.14.09-.28.14-.42l-.22-.41C396,254.46,394.76,252.22,393.34,249.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.71,254.31l1.66,5.69a12.7,12.7,0,0,0,.78,2.33,10.78,10.78,0,0,0-.43-2.43c-.24-1.07-.58-2.43-1-3.94q-.24-.87-.51-1.8c-.66-2.22-1.32-4.22-1.84-5.65a10.39,10.39,0,0,0-.95-2.27s0,.2.09.53.28,1,.51,1.86C381.51,250.26,382.08,252.19,382.71,254.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.36,251.94a10.69,10.69,0,0,0-.05,2.81,10.07,10.07,0,0,0,.22,2.8,10.42,10.42,0,0,0-.17-5.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.8,235.29c-.24-.45-.58-.44-.57-.42s.25.11.38.5a1,1,0,0,1,0,.7,1.63,1.63,0,0,1-.58.74c-1.26.84-3.14,2-5.13,3.27-.86.56-1.68,1.09-2.44,1.6-1,.66-1.91,1.28-2.65,1.78a12.51,12.51,0,0,0-2,1.53,12,12,0,0,0,2.22-1.22c1.34-.81,3.17-2,5.17-3.25s3.81-2.45,5.09-3.43a1.86,1.86,0,0,0,.56-.77.7.7,0,0,0,.06-.17A1.25,1.25,0,0,0,347.8,235.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.83,227.79c.31-.36.39-.62.37-.63a5.41,5.41,0,0,1-2.16,1.42c-.75.28-1.71.49-2.77.76l-3.43.92c-1.45.39-2.82.77-4,1.12l-2.18.64a13.34,13.34,0,0,0-2.52.88,13.84,13.84,0,0,0,2.62-.53c1.6-.38,3.81-1,6.24-1.61l3.42-.95a26.26,26.26,0,0,0,2.78-.89,6,6,0,0,0,.84-.45A3.65,3.65,0,0,0,343.83,227.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.16,218.91a14,14,0,0,0-2.53-.1c-1.55,0-3.7,0-6.07-.07s-4.51-.13-6.07-.19a13.49,13.49,0,0,0-2.52,0,2.34,2.34,0,0,0,.8.18c.42.06,1,.13,1.7.2,1.55.15,3.7.29,6.08.34.82,0,1.59,0,2.34,0,1.43,0,2.73,0,3.75-.1A10.86,10.86,0,0,0,342.16,218.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.87,217.65a11.47,11.47,0,0,0,3.38.33,21.88,21.88,0,0,0-6.66-1.18A11.23,11.23,0,0,0,338.87,217.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.34,194.06a18.69,18.69,0,0,0-1.45-3.31,19.13,19.13,0,0,0-1.62-3.23,15.56,15.56,0,0,0,3.07,6.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.39,190.9a81.44,81.44,0,0,0,3.42-8.38c1-2.7,1.87-5.11,2.39-6.68l-.29-.14c-.64,1.53-1.58,3.93-2.59,6.64A78.39,78.39,0,0,0,380.39,190.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.83,186.37a16.3,16.3,0,0,0,2.53-3.81,25.59,25.59,0,0,0-2.94,3.49,25.58,25.58,0,0,0-2.7,3.68A16.74,16.74,0,0,0,385.83,186.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.39,191.7a13.48,13.48,0,0,0,3.43-2.74,30.64,30.64,0,0,0-3.71,2.3,30.32,30.32,0,0,0-3.63,2.42A13.89,13.89,0,0,0,396.39,191.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.13,200.44a8.17,8.17,0,0,0-2.68,1.55,11,11,0,0,0,2.89-1.07,10.72,10.72,0,0,0,2.74-1.4A8.09,8.09,0,0,0,403.13,200.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.26,
    cy: 218.29,
    r: 24.93,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,270.21a2.59,2.59,0,0,1,.12.6c.06.46.14,1,.24,1.74.2,1.59.47,3.76.81,6.42.68,5.41,1.66,12.88,2.85,21.12s2.4,15.68,3.32,21.06c.45,2.64.81,4.8,1.08,6.37.12.71.21,1.28.28,1.74a3.74,3.74,0,0,1,.07.61,2.38,2.38,0,0,1-.17-.59c-.1-.45-.22-1-.38-1.72-.32-1.49-.74-3.66-1.25-6.35-1-5.36-2.26-12.8-3.46-21s-2.12-15.73-2.71-21.16c-.29-2.71-.51-4.91-.64-6.43-.06-.72-.11-1.3-.14-1.76A2.56,2.56,0,0,1,383,270.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.55,265c.14,0,1.33,20.34,2.66,45.45s2.3,45.46,2.15,45.47-1.34-20.34-2.67-45.45S368.4,265,368.55,265Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.59,269.4a2.13,2.13,0,0,1-.07.61c-.08.45-.19,1-.32,1.71-.31,1.55-.73,3.68-1.25,6.27-1.12,5.35-2.64,12.62-4.33,20.65s-3.32,15.28-4.48,20.61c-.58,2.58-1.06,4.7-1.41,6.24-.17.68-.3,1.24-.41,1.68a2.62,2.62,0,0,1-.18.59,2.51,2.51,0,0,1,.08-.61c.08-.44.18-1,.31-1.71.31-1.54.74-3.67,1.25-6.27,1.13-5.34,2.65-12.61,4.33-20.65s3.32-15.28,4.48-20.61c.59-2.58,1.07-4.7,1.42-6.24.16-.68.3-1.24.41-1.68A4.46,4.46,0,0,1,360.59,269.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.19,204.29l3.51,7.1a1.21,1.21,0,0,0,.9.66l7.84,1.13a1.2,1.2,0,0,1,.66,2l-5.67,5.52a1.19,1.19,0,0,0-.34,1.06l1.33,7.81a1.19,1.19,0,0,1-1.73,1.26l-7-3.69a1.23,1.23,0,0,0-1.12,0l-7,3.69a1.19,1.19,0,0,1-1.73-1.26l1.34-7.81a1.2,1.2,0,0,0-.35-1.06l-5.67-5.52a1.2,1.2,0,0,1,.67-2l7.83-1.13a1.21,1.21,0,0,0,.9-.66l3.51-7.1A1.19,1.19,0,0,1,373.19,204.29Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.6,202.08l.42,1.36a1.91,1.91,0,0,0,1.27,1.26l1.36.43-1.37.46a1.94,1.94,0,0,0-1.2,1.19l-.48,1.39-.53-1.45a1.94,1.94,0,0,0-1.2-1.16l-1.31-.43,1.29-.44a1.88,1.88,0,0,0,1.17-1.12Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M380.14,190.23a2.6,2.6,0,0,0-.19,1c.52.17,1,.35,1.54.55a3.58,3.58,0,0,0,.75-.7l10.14-12.75a3,3,0,0,0,.9-2.11.45.45,0,0,0,0-.11c-1.83-.15-3.93.76-5.76.19a13.59,13.59,0,0,1-1.29-.45c-.52,1.57-1.38,4-2.39,6.68a81.44,81.44,0,0,1-3.42,8.38,78.39,78.39,0,0,1,2.93-8.56c1-2.71,1.95-5.11,2.59-6.64a1.55,1.55,0,0,1-.22-.12l-.13.12Q382.85,183,380.14,190.23Zm5.28-4.18a25.59,25.59,0,0,1,2.94-3.49,16.3,16.3,0,0,1-2.53,3.81,16.74,16.74,0,0,1-3.11,3.36A25.58,25.58,0,0,1,385.42,186.05Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M392.8,189.25c1.69-1.83,3.24-3.47,4.38-4.64a12.67,12.67,0,0,1,1.93-1.82,13.72,13.72,0,0,1-1.66,2.07c-1.07,1.23-2.58,2.91-4.26,4.74s-3.24,3.48-4.38,4.64a2,2,0,0,0-.69,1.16l.57.44c5.85-3.46,12.57-7.84,17.78-11.7a4.29,4.29,0,0,0-1.63-1h0c-1.68-.58-3.75-.56-5.41-1.21-2.86,3-6.3,6.66-9.28,10.26C390.92,191.31,391.83,190.31,392.8,189.25Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M406.85,195a11.33,11.33,0,0,1-2,1.24c-1.23.72-2.94,1.7-4.8,2.83s-3.69,2.07-4.22,3.35a2.63,2.63,0,0,0-.24,1.24l.39.68c4.78-1,12.23-4.46,17.68-6.66-1.66-1.33-4.15-1.85-5.33-3.66L406.58,195C406.74,195,406.84,194.94,406.85,195Zm-3.51,6a11,11,0,0,1-2.89,1.07,14,14,0,0,1,5.63-2.47A10.72,10.72,0,0,1,403.34,200.92Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M411.39,206.21c-1.24.5-3,1.16-4.89,1.87s-3.67,1.31-4.94,1.72a8.59,8.59,0,0,1-2.09.57l0,0-.83.37a28.84,28.84,0,0,1,.66,3h.75c5.09-.13,13.35-.63,19.46-1a8.74,8.74,0,0,0-1.18-2c-1.09-1.37-2.44-2.63-2.92-4.31a6.5,6.5,0,0,1-.22-1.65l-2.58.85Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M409.91,220.18l-6.69-.51a16.18,16.18,0,0,1-2.77-.32,10.88,10.88,0,0,1,2.2-.06c-.84-.06-1.67-.11-2.51-.14h-.47c0,.83-.08,1.64-.17,2.45,5.25,2,13,4.72,19.05,6.93a3,3,0,0,0,.34-1.31c.07-2.39-2.81-4.22-2.66-6.53-.75-.06-1.49-.12-2.23-.2Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M401.67,229.41,398.91,228l-.78-.38A27.52,27.52,0,0,1,397,230.4c4.62,3.54,10.69,9.76,15.83,14.26a4.38,4.38,0,0,0,1.59-1.49c1.24-2.18-.45-4.83-.69-7.33-1.55-.77-3.9-2-6.52-3.39C405.06,231.3,403.12,230.23,401.67,229.41Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M402.42,241.87c-2.46-1.75-4.68-3.37-6.26-4.55-1.13-.85-1.94-1.47-2.29-1.79-.37.48-.75.95-1.15,1.4a9.54,9.54,0,0,0,1.24,1.53c3.44,3.61,8.84,9.79,12.89,14.2.94-1.56.71-3.83,1.84-5.36a3.71,3.71,0,0,1,.51-.54l-1.63-1.28C406.11,244.47,404.33,243.23,402.42,241.87Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M392.83,249.91c-.72-1.24-1.4-2.43-2-3.53a11.63,11.63,0,0,0-1.77-2.72,1.9,1.9,0,0,0-1.93-.43c-.47.17-.6.48-.64.44s0-.35.55-.63a2.09,2.09,0,0,1,2.09.22,16.88,16.88,0,0,0-1.47-1.72c-.52.36-1.05.72-1.59,1.05,1.15,5.84,4.16,14.39,7,21.22a3,3,0,0,0,2.32-.53c1.78-1.36,1.05-4.22,1.66-6.36l-.4-.64C395.61,254.66,394.27,252.41,392.83,249.91Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M384.72,259.9a10.78,10.78,0,0,1,.43,2.43,12.7,12.7,0,0,1-.78-2.33l-1.66-5.69c-.63-2.12-1.2-4.05-1.69-5.68-.23-.81-.41-1.45-.51-1.86l-.3-.7c-.26,5.7.08,13.69.47,20.1a25.74,25.74,0,0,1,4.81-3.22c-.46-2.23-1.07-4.62-1.77-7C384.14,257.47,384.48,258.83,384.72,259.9Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M372.05,261.92a16.46,16.46,0,0,1-.56,2.88,15.4,15.4,0,0,1,.2-2.93c.19-1.8.49-4.28.85-7l.54-3.86a5.89,5.89,0,0,0-.13-3,2.69,2.69,0,0,0-1.09-1.25l-.6,0c-.33,0-.66,0-1,0a.52.52,0,0,0-.11.1,5.84,5.84,0,0,0-1.19,2.29c-1.74,5.15-3.48,12.83-5.22,18.37,2.06-.43,3.39-2.94,5.52-3.08a3.94,3.94,0,0,1,2.61,1c.17-1.7.32-3.58.48-5.49C372.26,260.63,372.15,261.32,372.05,261.92Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M359.59,254c.61-1.24,1.21-2.44,1.66-3.53a8,8,0,0,0,.66-3,4.93,4.93,0,0,0-.41-2,1.66,1.66,0,0,0-1,.64c-3.88,4.31-9.35,11.26-13.33,16.63,2.2.83,5.22-.58,7.81-.3.24-.44.67-1.18,1.24-2.17C357.12,258.68,358.35,256.48,359.59,254Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M346.41,252.13c.7-.83,2.5-2.7,4.57-4.93,2.25-2.41,4.13-4.47,4.78-5.07-.65-.43-1.28-.88-1.9-1.35a30.59,30.59,0,0,1-2.49,2.1,14.37,14.37,0,0,1-3.12,2.1,13.22,13.22,0,0,1,2.8-2.51c.84-.65,1.61-1.21,2.18-1.59a14.63,14.63,0,0,0-3.38,2L338,251.76c2.06.36,4.39.45,5.68,2a3.71,3.71,0,0,1,.49.77C344.82,253.75,345.59,253,346.41,252.13Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M341.9,240.08c2-1.3,3.87-2.43,5.13-3.27a1.63,1.63,0,0,0,.58-.74,1,1,0,0,0,0-.7c-.13-.39-.4-.46-.38-.5s.33,0,.57.42a1.25,1.25,0,0,1,.09.86.7.7,0,0,1-.06.17,2.4,2.4,0,0,0,.78-.84c-.32-.43-.64-.87-.95-1.32a3.55,3.55,0,0,0-1.2.16c-5.35,1.41-13.52,4.46-19.89,6.82,2,1.46,5.65.83,6.94,3.08a3.48,3.48,0,0,1,.31.87c1.75-1.07,3.7-2.24,5.64-3.41C340.22,241.17,341,240.64,341.9,240.08Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M335.84,230.26l3.43-.92c1.06-.27,2-.48,2.77-.76a5.41,5.41,0,0,0,2.16-1.42s-.06.27-.37.63a3.65,3.65,0,0,1-.81.68l.43-.15a2.34,2.34,0,0,0,1-.58c-.18-.52-.35-1-.5-1.57a3.54,3.54,0,0,0-1.34-.24q-9.92-.35-19.84-.58c.92,1.56,3,2.25,3.82,3.86a4.61,4.61,0,0,1,.23,3.28l5-1.11C333,231,334.39,230.65,335.84,230.26Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M325,218.54a13.49,13.49,0,0,1,2.52,0c1.56.06,3.7.14,6.07.19s4.52.06,6.07.07a14,14,0,0,1,2.53.1,10.86,10.86,0,0,1-2.52.27c-1,.06-2.32.09-3.75.1,2.46.1,4.82.13,6.8,0h.16c0-.33,0-.66,0-1s0-.94,0-1.4l-.14-.09c-5.47-3.26-13.33-5.61-19.84-7.39a2.37,2.37,0,0,0,1.53,2.56l-.14-.9c1.61.7,2.05,2.87,1.54,4.55a12,12,0,0,1-1.56,3l1.52.09A2.34,2.34,0,0,1,325,218.54Zm14-1.41a11.35,11.35,0,0,1,3.29.85,11.47,11.47,0,0,1-3.38-.33,11.23,11.23,0,0,1-3.28-.85A11.37,11.37,0,0,1,339,217.13Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M327.39,203.74a16,16,0,0,1,2.66,1.15l2.07,1c1.84.79,3.76,1.59,5.63,2.33a30.87,30.87,0,0,0,5.32,1.41,2,2,0,0,0,1.08-.18.81.81,0,0,0,.14-.12c.2-.59.41-1.17.65-1.75-.92-.45-2.32-1.21-3.88-2.11a28.63,28.63,0,0,1-4.72-3,31.72,31.72,0,0,1,5,2.56l1.62,1A170.94,170.94,0,0,0,327.17,196c-.32,1.88.4,4.28-.18,6.23a5.52,5.52,0,0,1-.55,1.18l1.2.51C327.48,203.83,327.38,203.75,327.39,203.74Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M337.05,192.1a12.09,12.09,0,0,1,1.81,1.64c1.09,1,2.61,2.46,4.35,3.94s3.39,2.75,4.6,3.65l.41.31c.35-.48.7-.95,1.08-1.4l-.06-.1c-.53-.63-1.19-1.48-1.89-2.45a17.3,17.3,0,0,1-2.38-3.94,9.49,9.49,0,0,1,1.52,1.86,107.42,107.42,0,0,0-8-10.92,3.69,3.69,0,0,0-2.17,1.17c-1.11,1.35-.7,3.47-1.24,5.07,1,.92,2.19,1.94,3.41,3A9.69,9.69,0,0,1,337.05,192.1Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M350.69,189c2.5,3.16,4.59,5.68,4.54,5.84q.69-.47,1.41-.9c0-.07-.05-.13-.08-.19-1.88-4.8-5.29-12.32-7.57-17.81a10.56,10.56,0,0,0-1.06.55c-1.67,1-2.22,3.17-3.12,4.94.58.76,1.24,1.65,1.94,2.61S349,186.87,350.69,189Zm2.58-1.45a19.13,19.13,0,0,1,1.62,3.23,18.69,18.69,0,0,1,1.45,3.31,15.56,15.56,0,0,1-3.07-6.54Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M359.41,177.76a11.78,11.78,0,0,1,.48,2.23c.24,1.37.57,3.28,1,5.37.36,1.83.71,3.47,1,4.78.14.43.28.82.42,1.18.53-.18,1.07-.34,1.63-.49a25.08,25.08,0,0,1-.51-3.31,15.54,15.54,0,0,1-.34-3.38,9.08,9.08,0,0,1,.86,3.32c.09.66.13,1.28.15,1.81,0-5.17.11-11.82.1-17.08-.83.79-1.44,2.17-2.78,4.15a2.76,2.76,0,0,1-2.06,1.14l.06.39C359.39,177.81,359.4,177.76,359.41,177.76Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M372,183.15c-.05,2.91-.14,5.43-.25,6.72.68,0,1.36,0,2,.11a15.84,15.84,0,0,0,2.2-5.53c.88-3.51,2.09-9.15,3.07-13.27a4.32,4.32,0,0,0-1.77.51c-1.54.85-3.41,4.57-4.38,4.59a1.27,1.27,0,0,1-.9-.48l0,.42C372,177.44,372,180.08,372,183.15Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWinnersPana, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Winners-pana.b9c016b9.svg";
export { ForwardRef as ReactComponent };